{
  "RECEIPT — Reviewer desk": "RECEIPT — 审核工作台",
  "Reviewer desk": "审核工作台",
  "Back to wallet →": "返回钱包 →",
  "Every receipt.": "每一张小票，",
  "A considered decision.": "都认真核查。",
  "Follow automatic receipt checks, resolve exceptions, and manage reward reservations. Accounting budget and funded onchain assets are shown separately.": "查看自动核验结果、处理异常并管理奖励预留。账面预算与链上已到位资产分别显示。",
  "01 · Reviewer wallet": "01 · 审核钱包",
  "Connect reviewer wallet": "连接审核钱包",
  "Disconnect": "断开连接",
  "Only a wallet in this server's configured reviewer list can access receipts. Sign-in is a message signature. Preparing or sending a Vault transaction is a separate action.": "只有已配置的审核钱包才能查看小票。登录需要签署验证消息；准备或发送金库交易需要另行操作。",
  "02 · Receipt queue": "02 · 小票队列",
  "Refresh": "刷新",
  "Show receipts": "查看小票",
  "Automatic checks / exceptions": "自动核验 / 异常复核",
  "Budget reserved": "预算已预留",
  "Reservation prepared": "预留交易已准备",
  "Ready to claim": "可以领取",
  "Delivered": "已到账",
  "Payment needs recheck": "付款待复核",
  "Not approved": "未通过",
  "Reservation expired": "预留已过期",
  "All records": "全部记录",
  "Loading receipt queue…": "正在加载小票队列…",
  "Load more receipts": "加载更多小票",
  "03 · Accounting budget": "03 · 账面预算",
  "These dollar amounts are internal accounting. Adding an entry does not fund a contract or prove custody of stock or other assets.": "这些美元金额用于内部记账。增加账目不会向合约注资，也不能证明已持有股票或其他资产。",
  "Add to accounting budget · USD": "增加账面预算 · 美元",
  "Unique accounting reference": "唯一记账编号",
  "A meaningful, unique reference": "填写有明确含义的唯一编号",
  "Record budget entry": "记录预算",
  "Automatic receipt policy": "自动核验规则",
  "Checking the current receipt policy…": "正在查询当前核验规则…",
  "Retry up to 20 queued checks": "重试最多 20 项排队核验",
  "Operational readiness": "运行准备情况",
  "Checking configuration…": "正在检查配置…",
  "Onchain delivery requires the configured Vault, a permitted reward asset, sufficient free funds and a verified reservation. Stock delivery additionally requires an issuer integration.": "链上发放需要配置金库、允许的奖励资产、足够的可用资金和已验证的预留。股票代币发放还需完成发行方对接。",
  "04 · Onchain treasury": "04 · 链上金库",
  "Read Vault balances": "读取金库余额",
  "Onchain balances are unavailable until a Vault and RPC are configured.": "配置金库和链上连接后才能读取余额。",
  "These are contract balances in exact token base units, read at the displayed block. They are separate from the dollar accounting budget. No stock-price conversion or issuer custody is implied.": "这里显示指定区块的合约余额，单位为代币最小单位，与美元账面预算分开计算。不代表股票估值或发行方托管证明。",
  "Treasury action": "金库操作",
  "Account for deposited quote funds": "登记已存入的计价资产",
  "Change Vault pause state": "更改金库暂停状态",
  "Purchase a permitted reward asset": "采购允许的奖励资产",
  "New pause state": "新的暂停状态",
  "Pause Vault operations": "暂停金库操作",
  "Resume Vault operations": "恢复金库操作",
  "Permitted purchase adapter": "允许的采购适配器",
  "Reward asset address": "奖励资产地址",
  "Quote amount to spend · base units": "支付的计价资产数量 · 最小单位",
  "Positive integer": "填写正整数",
  "Minimum reward asset received · base units": "最低奖励资产到账量 · 最小单位",
  "Purchase deadline · local time": "采购截止时间 · 本地时间",
  "Sync accounts for quote assets already deposited in this Vault. It does not deposit or withdraw funds.": "同步金库中已存入的计价资产记录。此操作不会存入或提取资金。",
  "Prepare unsigned treasury transaction": "准备未签名的金库交易",
  "Confirm treasury transaction in wallet": "在钱包中确认金库交易",
  "Treasury transaction hash": "金库交易哈希",
  "Verify treasury transaction": "核验金库交易",
  "Local BSC implementation. Decisions are recorded for audit. No receipt is marked paid by an approval or by accepting a transaction hash.": "本地 BSC 版本。审核决定会留存记录；仅批准小票或接收交易哈希不会将其标记为已付款。",
  "Private receipt review": "私密小票审核",
  "Close receipt review": "关闭小票审核",
  "Review receipt": "审核小票",
  "Automatic check result": "自动核验结果",
  "Retry this receipt's automatic checks": "重新自动核验此小票",
  "Merchant": "商户",
  "Purchase date": "消费日期",
  "Receipt total · original currency": "小票总额 · 原币种",
  "Currency": "币种",
  "Decision reason": "决定原因",
  "Record what you checked and why this decision is appropriate.": "记录核查内容及作出此决定的理由。",
  "Approve & reserve budget": "批准并预留预算",
  "Reject receipt": "拒绝此小票",
  "Approval verifies your corrected fields, checks for duplicate purchases and reserves accounting budget atomically. It does not send assets.": "批准时会校验更正后的字段、检查重复消费并一次性预留账面预算，不会发送资产。",
  "Convert approved dollars to reward tokens": "将已批准的美元奖励换算为代币",
  "Record a manually checked USD price per whole reward token. The server reads the token's decimals and rounds down. This is a reviewer quote with an audit trail; its market price is not independently verified.": "填写人工核实的每枚奖励代币美元价格。服务器读取代币精度后向下取整；此报价留有审核记录，但未经独立行情验证。",
  "USD price per whole reward token": "每枚奖励代币的美元价格",
  "For example 200.00": "例如 200.00",
  "Price observed · your local time": "价格观察时间 · 本地时间",
  "Price source and reference": "价格来源与参考依据",
  "Source page or reviewed quotation reference": "来源页面或已审核的报价编号",
  "Quote validity · seconds from observation": "报价有效期 · 从观察时间起计算的秒数",
  "Calculate and save price quote": "计算并保存报价",
  "Funded onchain reservation": "资金已到位的链上预留",
  "Permitted reward asset · contract address": "允许的奖励资产 · 合约地址",
  "Exact token amount · base units": "精确代币数量 · 最小单位",
  "Positive integer, no decimal point": "填写正整数，不含小数点",
  "Claim deadline · your local time": "领取截止时间 · 本地时间",
  "Prepare unsigned reservation": "准备未签名的预留交易",
  "Confirm reservation in wallet": "在钱包中确认预留",
  "Reservation transaction hash": "预留交易哈希",
  "Verify reservation transaction": "核验预留交易",
  "The transaction must come from an authorized Vault operator. The server checks the expected reservation event and onchain state before enabling claims.": "交易须由获授权的金库操作员发起。服务器核对预留事件和链上状态后才开放领取。",
  "Expired unsent preparation": "已过期且未发送的准备记录",
  "This preparation is past its deadline. The server must verify that no reservation was ever created onchain and that sufficiently confirmed chain time has passed the deadline before releasing its accounting budget. This action requests no wallet signature and sends no transaction.": "该准备记录已超过截止时间。释放账面预算前，服务器须确认链上从未建立此预留，且充分确认的链上时间已超过截止时间。此操作不请求签名，也不发送交易。",
  "Release expired unsent preparation": "释放已过期且未发送的准备记录",
  "Expired reservation": "已过期的预留",
  "The claim deadline has passed. Release the expired reservation to restore the Vault's available balance; this does not send funds to the reviewer.": "领取时间已过。释放过期预留可恢复金库可用余额，不会向审核员发送资金。",
  "Review expiry release transaction": "审阅到期释放交易",
  "Confirm expiry release in wallet": "在钱包中确认到期释放",
  "Expiry release transaction hash": "到期释放交易哈希",
  "Verify expiry & release budget": "核验到期并释放预算",
  "Recorded payment evidence": "已记录的付款凭据",
  "Recheck recorded payment": "重新核验付款记录",
  "This reads the receipt, Vault event and recipient transfer again. It does not send another payment or release the reward budget.": "重新读取交易回执、金库事件和接收方转账，不会再次付款或释放奖励预算。",
  "Use a positive amount with at most two decimal places.": "请填写正数，最多保留两位小数。",
  "The amount must be a positive, valid monetary value.": "金额必须为有效正数。",
  "No reviewers are configured on this server. A normal wallet cannot grant itself access.": "服务器尚未配置审核钱包，普通钱包不能自行获得审核权限。",
  "Verify a configured reviewer wallet to open this desk.": "请验证已配置的审核钱包以打开工作台。",
  "is verified but is not a configured reviewer.": "已验证，但不在审核钱包名单中。",
  "Reviewer verified ·": "审核钱包已验证 ·",
  "Project token address": "项目代币地址",
  "Chain connection": "链上连接",
  "Reward Vault address": "奖励金库地址",
  "Permitted reward assets": "允许的奖励资产",
  "Stock reward mapping": "股票奖励映射",
  "Administrator wallet": "管理员钱包",
  "Receipt submission": "小票提交",
  "Project token configured; wallet holdings are checked before submission.": "项目代币已配置，提交前会检查持仓。",
  "Project token address required.": "需要配置项目代币地址。",
  "Receipt review": "小票审核",
  "Automatic policy checks enabled; exceptions enter the review queue.": "已启用自动核验，异常小票进入复核队列。",
  "Automatic checks disabled; receipts require review.": "自动核验未启用，小票需要人工审核。",
  "Reward delivery": "奖励发放",
  "Configured; permissions, holdings and available funds are checked for each reward.": "已配置，每笔奖励都会检查权限、持仓和可用资金。",
  "Configuration incomplete.": "配置尚不完整。",
  "Image assistance": "图像辅助",
  "Enabled as supporting evidence.": "已启用，作为辅助依据。",
  "Disabled; local policy checks remain available.": "未启用，本地规则核验仍可使用。",
  "Network": "网络",
  "Chain": "链",
  "Still needed": "仍需完成",
  "DELIVERY CONFIGURED": "发放已配置",
  "DELIVERY UNAVAILABLE": "发放尚不可用",
  "Detailed readiness information is not available.": "暂时无法获取详细准备情况。",
  "No stock issuer is implied by these checks.": "这些检查不代表已完成股票发行方对接。",
  "No review note": "暂无审核备注",
  "No receipts in this queue.": "此队列暂无小票。",
  "Loading…": "正在加载…",
  "Updated": "已更新",
  "Your reviewer session expired.": "审核会话已过期。",
  "The displayed queue may be stale.": "当前队列可能不是最新状态。",
  "Automatic checks must be enabled before queued receipts can be retried.": "启用自动核验后才能重试排队的小票。",
  "The current policy could not be loaded. Existing receipts and payment evidence remain available.": "无法加载当前规则，已有小票与付款凭据仍然保留。",
  "Retrying queued checks…": "正在重试排队核验…",
  "Checked": "已检查",
  "queued receipts;": "张排队小票；",
  "approved and reserved. No asset transfer was sent.": "张已批准并预留预算。未发送资产。",
  "The retry request completed. Refresh the queue to inspect each recorded outcome.": "重试请求已完成，请刷新队列查看各项结果。",
  "Rechecking receipt…": "正在重新核验小票…",
  "Accounting budget reserved; no asset was sent.": "账面预算已预留，未发送资产。",
  "Review the recorded evidence below.": "请查看下方记录的依据。",
  "Automatic checks found an exception. Review its evidence and image before recording a manual decision.": "自动核验发现异常，请先检查相关依据和图片，再记录人工决定。",
  "Evidence:": "核验依据：",
  "not recorded": "未记录",
  "Payment evidence has not been checked in this view.": "尚未在此页面核验付款凭据。",
  "Receipt to review": "待审核小票",
  "Status": "状态",
  "Wallet": "钱包",
  "Unavailable": "暂不可用",
  "Receipt ID": "小票编号",
  "Calculated reward": "计算所得奖励",
  "Current reason": "当前原因",
  "None": "无",
  "Saved manual price": "已保存的人工价格",
  "per whole token": "每枚代币",
  "Calculated quantity": "计算所得数量",
  "base units /": "最小单位 /",
  "Price source": "价格来源",
  "Price observed": "价格观察时间",
  "This is the immutable price record used for preparation. The market price was entered by a reviewer, not independently verified.": "这是准备交易时使用的固定价格记录。市场价格由审核员填写，未经独立验证。",
  "The private image is unavailable. Do not approve a receipt you cannot verify.": "无法显示私密图片，请勿批准无法核实的小票。",
  "Verified purchase allocation": "已验证的采购分配",
  "exact base units": "精确最小单位",
  "Purchase batch": "采购批次",
  "Purchase fill": "采购成交",
  "This allocation fixes the reward asset and amount. A manual quote cannot replace it. The receipt remains unpaid until its claim transfer is verified.": "此分配已固定奖励资产和数量，人工报价不能替换。领取转账核验通过前，小票仍为未付款。",
  "Preparation verifies the permitted asset and available Vault balance. Review the exact transaction before opening your wallet.": "准备时会核验允许的资产和金库可用余额。打开钱包前请审阅具体交易。",
  "The Vault and delivery assets are not configured. This accounting reservation cannot currently become claimable.": "金库和发放资产尚未配置，此账面预留暂时不能开放领取。",
  "The server must verify this reward ID is absent from sufficiently confirmed and current chain state after its fixed deadline before releasing the accounting allocation. This requests no signature and sends no transaction. Historical records and reward ID remain preserved.": "释放账面分配前，服务器须确认固定截止时间后，当前及充分确认的链上状态均不存在此奖励编号。此操作不签名、不发交易，保留历史记录和奖励编号。",
  "The recorded historical payment is disputed. Current and sufficiently confirmed chain state show this reward ID absent after its fixed deadline. The server will verify that evidence again before releasing the accounting allocation; historical payment records are preserved.": "历史付款记录存在争议。固定截止时间后的当前及充分确认链上状态均未发现此奖励编号。服务器会再次核验后释放账面分配，并保留历史付款记录。",
  "Recovery availability cannot be verified:": "暂时无法核实恢复条件：",
  "Record a specific reason for this decision.": "请填写作出此决定的具体原因。",
  "Recording decision…": "正在记录决定…",
  "Decision recorded and accounting budget reserved. No asset was sent.": "决定已记录，账面预算已预留，未发送资产。",
  "Rejection recorded. No reward was paid.": "拒绝原因已记录，未支付奖励。",
  "Provide a meaningful unique accounting reference.": "请填写有明确含义且唯一的记账编号。",
  "Recording…": "正在记录…",
  "Accounting entry recorded. No onchain funds were deposited.": "账目已记录，未向链上存入资金。",
  "Enter a valid asset address, positive integer token amount and a future deadline.": "请填写有效的资产地址、正整数代币数量和未来的截止时间。",
  "Checking Vault funds…": "正在检查金库资金…",
  "The saved price quote has expired. Record a fresh price before preparing this reservation.": "保存的报价已过期，请先记录新价格，再准备预留。",
  "The fixed reward recipient is missing. No transaction can be prepared.": "缺少固定的奖励接收方，无法准备交易。",
  "The prepared transaction does not match this receipt, recipient, asset, amount and deadline.": "准备的交易与此小票的接收方、资产、数量或截止时间不符。",
  "Reserve this exact reward": "预留这笔精确奖励",
  "Claim deadline:": "领取截止时间：",
  "Unsigned transaction prepared. Review every field before opening the operator wallet.": "未签名交易已准备，请核对全部字段后再打开操作员钱包。",
  "Awaiting operator wallet…": "等待操作员钱包…",
  "Submitted": "已提交",
  "Enter the complete reservation transaction hash.": "请输入完整的预留交易哈希。",
  "Verifying reservation…": "正在核验预留…",
  "Reservation verified against the Vault event and state. The recipient can now review a claim transaction.": "已核对金库预留事件和状态，接收方现在可以审阅领取交易。",
  "Reservation verification returned successfully. Refresh the receipt record to check whether it is claimable; it has not been paid.": "预留核验请求已完成。请刷新小票确认是否可领取；此时尚未付款。",
  "The quoted asset or quantity was edited. Preparation now uses the explicit manual amount; calculate again to bind a price quote.": "报价资产或数量已修改，现在使用明确填写的人工数量。重新计算可再次绑定报价。",
  "Checking decimals and price…": "正在核查精度与价格…",
  "Set the time this price was observed.": "请设置观察到此价格的时间。",
  "The quoted reward does not match this receipt.": "报价奖励与此小票不符。",
  "Approved reward": "已批准的奖励",
  "Manual price": "人工价格",
  "Token decimals": "代币精度",
  "Exact token amount": "精确代币数量",
  "base units (rounded down)": "最小单位（向下取整）",
  "Observed / expires": "观察 / 到期时间",
  "Quote reference": "报价编号",
  "Manual price quote saved and bound to the fields below. Prepare the reservation before this price quote expires.": "人工报价已保存并绑定到下方字段，请在报价过期前准备预留。",
  "Price inputs changed. Calculate a new quote before preparing the reward.": "价格输入已变更，请重新计算报价后再准备奖励。",
  "Rechecking chain evidence…": "正在重新核验链上凭据…",
  "The current chain evidence verifies the recorded payment.": "当前链上凭据已验证此付款记录。",
  "The payment is not currently verified. Its accounting allocation remains occupied.": "付款目前未通过核验，仍占用相应账面预算。",
  "Checking expired reservation…": "正在检查过期预留…",
  "The prepared call does not match this reservation release.": "准备的调用与此预留释放操作不符。",
  "Returned to the Vault’s available balance; no payout": "退回金库可用余额，不发放奖励",
  "Release the expired reservation": "释放过期预留",
  "Only after verified release will the accounting budget become available again.": "释放交易核验通过后，账面预算才会恢复可用。",
  "Review the release transaction. It does not deliver a reward.": "请审阅释放交易，此操作不会发放奖励。",
  "Awaiting wallet…": "等待钱包确认…",
  "Release submitted:": "释放交易已提交：",
  "Enter the complete expiry release transaction hash.": "请输入完整的到期释放交易哈希。",
  "Verifying release…": "正在核验释放交易…",
  "Expiry release verified. The accounting reservation has been released; no reward was paid.": "到期释放已验证，账面预留已释放，未支付奖励。",
  "The release was checked. Refresh the receipt and budget to see the latest verified state.": "释放操作已检查，请刷新小票和预算查看最新核验状态。",
  "Verifying unsent expiry…": "正在核验未发送的过期记录…",
  "The server verified this reward ID is absent from sufficiently confirmed and current chain state after its deadline, and released the accounting budget. Historical evidence was preserved. No transaction was sent.": "服务器已确认截止时间后的当前及充分确认链上状态不存在此奖励编号，并释放了账面预算。历史凭据已保留，未发送交易。",
  "The server completed the request. The queue and budget were refreshed; no wallet transaction was sent.": "请求已完成，队列和预算已刷新，未发送钱包交易。",
  "Opening reviewer wallet…": "正在打开审核钱包…",
  "Disconnected.": "已断开连接。",
  "· reviewer desk": "· 审核工作台",
  "Retry connection": "重新连接",
  "RECEIPT — Your BSC receipt desk": "RECEIPT — 你的 BSC 小票工作台",
  "Skip to your receipt desk": "跳转到小票工作台",
  "Main navigation": "主导航",
  "Home": "首页",
  "The rules ↗": "奖励规则 ↗",
  "YOUR EVERYDAY RECEIPTS, RECONSIDERED": "让日常小票，多一份可能",
  "A little piece. All yours.": "小小一份，属于你。",
  "Keep your receipts. Track your rewards. One place for every step, from the first scan to your BSC wallet.": "保存小票，查看奖励。从首次扫码到 BSC 钱包到账，在这里跟进每一步。",
  "ONE HOLDING REQUIREMENT": "统一持仓门槛",
  "Loading configuration": "正在加载配置",
  "Explore a read-only example →": "查看只读示例 →",
  "Checking scanning and reward delivery availability…": "正在检查扫码与奖励发放状态…",
  "A LITTLE MORE FROM EVERY RECEIPT": "每张小票，都多一份可能",
  "Your purchases.": "你的消费，",
  "Your next piece.": "你的下一份奖励。",
  "Scan an eligible receipt and follow its reward here, from review to a verified BSC delivery.": "扫描符合条件的小票，在这里跟进审核及 BSC 奖励到账情况。",
  "First release": "首批上线",
  "7 brands": "7 个品牌",
  "Minimum holding": "最低持仓",
  "Reward network": "奖励网络",
  "BNB Smart Chain": "BNB 智能链",
  "ONE REQUIREMENT. SAME RULE FOR EVERY WALLET.": "统一门槛，所有钱包适用同一规则。",
  "Explore an example →": "查看示例 →",
  "Scan": "扫码",
  "Review": "审核",
  "Receive": "领取",
  "YOUR REWARD DESK": "你的奖励工作台",
  "Receipt reward allocations": "小票奖励分配",
  "Historical reward accounting · not your current stock balance.": "历史奖励记账金额，不代表当前股票代币余额。",
  "Rewards by stock": "按股票查看奖励",
  "Matched to your brands": "对应你的消费品牌",
  "Waiting for receipt records…": "等待小票记录…",
  "Amounts below are USD reward allocations. A transfer is verified separately in each receipt.": "下方金额为美元计价的奖励分配。每笔小票的实际到账分别核验。",
  "Daily allowance & eligibility": "每日额度与持仓资格",
  "Reserved today": "今日已预留",
  "Receipts today": "今日小票",
  "Welcome $5": "首次 5 美元奖励",
  "Per receipt, up to": "每张奖励上限",
  "$RECEIPT holder": "$收据 持有人",
  "Your receipt history": "小票记录",
  "Counts cover the records currently loaded.": "统计仅涵盖当前已加载的记录。",
  "Loaded receipt statistics": "已加载小票统计",
  "Waiting": "处理中",
  "Rejected": "未通过",
  "Loading reward records…": "正在加载奖励记录…",
  "Load older receipts": "加载更早的小票",
  "Wallet and receipt tools": "钱包与小票工具",
  "Scanner unavailable": "扫码暂不可用",
  "Scanning has not been enabled on this server. The read-only preview remains available.": "服务器尚未启用扫码，你仍可查看只读示例。",
  "Wallet · BNB Smart Chain": "钱包 · BNB 智能链",
  "Ready when you are.": "准备好，就开始。",
  "Your email": "邮箱地址",
  "Continue with email": "通过邮箱继续",
  "Email verification code": "邮箱验证码",
  "6-digit code": "6 位验证码",
  "Verify email & sign in": "验证邮箱并登录",
  "Creates your own BSC wallet with Privy. Sign-in proves wallet ownership; transfers require a separate review.": "通过 Privy 创建你自己的 BSC 钱包。登录用于验证钱包归属，转账需要另行审阅确认。",
  "or use your existing wallet": "或使用已有钱包",
  "Connect wallet": "连接钱包",
  "Connect and verify with a single-use sign-in message from this server. Verification moves no funds. Claiming a funded reward is a separate transaction.": "签署服务器提供的一次性登录消息以连接并验证钱包。验证不会转移资金；领取奖励是另一笔交易。",
  "Wallet eligibility": "钱包资格",
  "WALLET NOT CONNECTED": "尚未连接钱包",
  "At least 1,000,000 $RECEIPT is required to submit or claim.": "提交或领取需要至少持有 1,000,000 枚 $收据。",
  "Recheck token balance": "重新检查持仓",
  "Open reviewer desk →": "打开审核工作台 →",
  "02 · Open on your phone": "02 · 在手机上打开",
  "Link expires in": "链接剩余时间",
  "Copy link": "复制链接",
  "New link": "创建新链接",
  "Point your phone's camera at the code. Keep this private link to yourself; it grants access to your scanner session.": "使用手机相机扫描二维码。此链接可以访问你的扫码会话，请妥善保管，不要分享。",
  "You're on a phone already.": "你正在使用手机。",
  "Open the scanner →": "打开扫码页面 →",
  "SCANNER · PREVIEW": "扫码 · 预览",
  "Paper in. Possibilities out.": "一张小票，多一份可能。",
  "In your wallet session, create a private camera link and open it on your phone.": "登录钱包后创建私密相机链接，再用手机打开。",
  "MERCHANT · DATE · TOTAL": "商户 · 日期 · 总额",
  "Keep all three in the frame.": "请将三项信息完整拍入画面。",
  "This preview has no camera session or private QR code.": "此预览不包含相机会话或私密二维码。",
  "What makes a receipt eligible →": "哪些小票符合条件 →",
  "STOCK EXCHANGE": "股票代币兑换",
  "A simple service fee.": "清楚明白的服务费。",
  "When exchange is available, the fee is taken once from the stock or tokens you receive.": "兑换启用后，服务费从你实际收到的股票代币或其他代币中扣除一次。",
  "Example output": "到账量示例",
  "100 tokens": "100 枚代币",
  "Service fee": "服务费",
  "You receive": "你实际收到",
  "Fee illustration only, not a market quote. Gas and slippage are separate. Scanning and claiming have no exchange service fee.": "仅为费用示例，不是市场报价。网络费与滑点另计；扫码和领取不收取兑换服务费。",
  "Checking exchange availability…": "正在检查兑换状态…",
  "Read the exchange policy →": "查看兑换规则 →",
  "Find your receipt brand": "查找小票对应品牌",
  "USD receipts only. The merchant and purchase must fit the matching scope below. Matching is subject to review; reward delivery is pending launch.": "仅支持美元小票，商户和消费内容须符合下方范围。匹配结果需审核。",
  "Open receipt": "查看小票",
  "Merchant or ticker": "商户或股票代码",
  "Apple, AAPL, groceries…": "苹果、AAPL、日常采购…",
  "Category": "分类",
  "All categories": "全部分类",
  "Receipt brand directory": "小票品牌目录",
  "Apple": "苹果",
  "Example mapping · delivery pending": "匹配示例 · 尚待发放",
  "Amazon": "亚马逊",
  "Costco": "开市客",
  "GameStop": "游戏驿站",
  "Loading the selected receipt brands. Examples remain available below.": "正在加载已选择的品牌，下方仍可查看示例。",
  "Coming later · BSC brands": "后续上线 · BSC 品牌",
  "Loading the later-stage brand list…": "正在加载后续品牌…",
  "These receipts are not eligible yet. Each new asset must pass route, cost and delivery checks before activation.": "这些品牌的小票尚不符合奖励条件。每项新资产启用前都须完成路线、成本和发放检查。",
  "Checking the receipt review policy…": "正在检查小票审核规则…",
  "Local BSC implementation. A reservation is not a delivered asset. No stock issuer is configured. Real delivery requires a funded, verified onchain reservation and a confirmed transfer to the fixed recipient. Brands are references, not partners.": "本地 BSC 版本。预留不代表资产已到账，股票发行方尚未配置。实际发放需要资金到位的链上预留，以及向固定接收方成功转账的凭据。所列品牌仅供匹配参考，不代表合作关系。",
  "Read all receipt rules →": "查看完整小票规则 →",
  "Back to the receipt roll →": "返回首页 →",
  "Your receipt": "你的小票",
  "Close receipt details": "关闭小票详情",
  "Receipt details": "小票详情",
  "Reason for review": "复核原因",
  "Explain what needs another look.": "说明需要重新核查的内容。",
  "Request another review": "申请复核",
  "Review claim transaction": "审阅领取交易",
  "Confirm claim in wallet": "在钱包中确认领取",
  "Check delivery confirmation": "核验到账情况",
  "Recover or replace a transaction hash": "恢复或更换交易哈希",
  "Paste the full hash from your wallet or block explorer if this browser lost it, or if your wallet sped up the transaction. Checking a hash never requests a signature. A cancelled or reverted transaction is not a reward payment.": "若浏览器未保存哈希，或你在钱包中加速了交易，可从钱包或区块浏览器粘贴完整哈希。核验哈希不会请求签名；取消或回滚的交易不算奖励到账。",
  "Claim or replacement transaction hash": "领取或替换交易的哈希",
  "Check this transaction": "核验此交易",
  "Clear saved browser reference": "清除浏览器保存的记录",
  "Use your wallet's Speed up or Cancel controls for a pending transaction. Clearing this browser reference does not cancel it; a duplicate claim can still cost gas.": "待处理交易可使用钱包的“加速”或“取消”功能。清除浏览器记录不会取消链上交易，重复领取仍可能消耗网络费。",
  "YOUR BSC WALLET": "你的 BSC 钱包",
  "Close wallet action": "关闭钱包操作",
  "Review transaction": "审阅交易",
  "Confirm transaction": "确认交易",
  "Check onchain result": "核验链上结果",
  "Full transaction hash": "完整交易哈希",
  "Check this hash": "核验此哈希",
  "Check your wallet first. Missing or delayed confirmation does not mean a transaction failed. No action is resent automatically.": "请先检查钱包。确认缺失或延迟不代表交易失败，系统不会自动重新发送。",
  "Create scanner link": "创建扫码链接",
  "Check your token balance before using this scanner link. Existing receipts and transaction records are preserved.": "使用扫码链接前请先检查持仓，已有小票和交易记录会保留。",
  "Checking the current token balance…": "正在检查当前代币余额…",
  "Verified wallet ·": "已验证钱包 ·",
  "Your wallet session expired. Verify again to check your balance.": "钱包会话已过期，请重新验证后检查余额。",
  "Verified ·": "已验证 ·",
  "Loading older receipts…": "正在加载更早的小票…",
  "Used once": "已使用",
  "Available on first approval": "首次通过审核时可用",
  "· example": "· 示例",
  "Example only. Real submissions and claims require at least 1,000,000 $RECEIPT and a current balance check.": "仅为示例。实际提交和领取需要至少持有 1,000,000 枚 $收据，并完成当前余额检查。",
  "Showing": "当前显示",
  "receipt records.": "条小票记录。",
  "New activity is available; Refresh returns to the latest records.": "有新记录，点击刷新可返回最新记录。",
  "Older records are available below.": "下方还有更早的记录。",
  "End of available history.": "已显示全部可用历史。",
  "This server returned its latest 200 records without pagination. Older history is not confirmed complete.": "服务器返回了最近 200 条记录，未提供分页信息，无法确认更早历史是否完整。",
  "This server response does not include pagination metadata.": "服务器响应不包含分页信息。",
  "Read-only examples. These records do not use real budgets or represent delivered assets.": "只读示例，不使用实际预算，也不代表资产已到账。",
  "Your session expired. Verify your wallet again.": "会话已过期，请重新验证钱包。",
  "The last displayed records may be stale.": "上次显示的记录可能已过时。",
  "Example records only. No assets were delivered.": "仅为示例记录，未发放资产。",
  "Counts and brand totals cover": "数量和品牌汇总涵盖",
  "loaded records. Waiting includes payments that need another check.": "条已加载记录。“处理中”包含需要再次核验的付款。",
  "Example allocation": "分配示例",
  "Reward allocation": "奖励分配",
  "No reward allocations in the loaded receipts yet.": "已加载的小票暂无奖励分配。",
  "\" aria-label=\"View": "查看",
  "No receipts yet.": "暂无小票。",
  "Once your holding is verified, open the scanner on your phone for automatic receipt checks.": "持仓验证后，在手机上打开扫码页面即可自动核验小票。",
  "The recorded payment is not currently verified. Recheck its chain evidence; its accounting allocation remains occupied.": "付款记录目前未通过核验。请重新检查链上凭据，相应账面预算仍被占用。",
  "A scanner link is already being created. Wait for that request to finish.": "扫码链接正在创建，请等待当前请求完成。",
  "The scanner is not configured on this server.": "服务器尚未配置扫码功能。",
  "Verify your wallet before creating a scanner link.": "创建扫码链接前请先验证钱包。",
  "Creating a private scanner link…": "正在创建私密扫码链接…",
  "The server returned an invalid or expired scanner link. Try creating a new link.": "服务器返回的扫码链接无效或已过期，请重新创建。",
  "Private scanner link QR code": "私密扫码链接二维码",
  "QR display unavailable. Use the private text link below.": "二维码暂时无法显示，请使用下方私密文字链接。",
  "This local address works on this device only. A configured HTTPS address reachable by your phone is needed for cross-device scanning.": "此本地地址只能在当前设备使用。跨设备扫码需要手机能够访问的 HTTPS 地址。",
  "Link valid for 15 minutes. Anyone with this link can submit to this wallet; keep it private.": "链接有效期为 15 分钟。持有链接的人可以向此钱包提交小票，请勿分享。",
  "Expired": "已过期",
  "This scanner link has expired. Use New link or Create scanner link to continue.": "扫码链接已过期，请点击“创建新链接”或“创建扫码链接”继续。",
  "Earlier reference": "较早记录",
  "Current reference": "当前记录",
  "Use this earlier hash for checking": "使用此较早哈希核验",
  "Review recovery of this same reward": "审阅原奖励的恢复操作",
  "Your holding is checked again before preparing and confirming this claim. Falling below 1,000,000 tokens pauses new claims; your original reward record remains.": "准备和确认领取前会再次检查持仓。低于 1,000,000 枚会暂停新的领取，原奖励记录仍然保留。",
  "The recorded payment needs another onchain check and its budget remains reserved. Recheck the payment hash first. Recovery can use only this original reward, after the server verifies that its reservation is still funded, active and unpaid.": "付款记录需要再次链上核验，其预算仍被预留。请先核验付款哈希；只有确认原预留资金到位、有效且未付款后，才能恢复同一笔奖励。",
  "A transaction reference was saved:": "已保存交易记录：",
  "This is an example. No signature, receipt upload or reward transaction is available in preview.": "这是示例。预览不提供签名、小票上传或奖励交易。",
  "Onchain delivery is not configured. This record does not represent a stock payment.": "链上发放尚未配置，此记录不代表股票代币已付款。",
  "The server previously verified the Vault event and recipient transfer. Recheck if the transaction or chain status has changed.": "服务器此前已核验金库事件和接收方转账；若交易或链状态改变，请重新核验。",
  "Only a funded, verified onchain reservation can be claimed.": "只有资金到位并已验证的链上预留才能领取。",
  "The original reservation could not be checked.": "暂时无法检查原始预留。",
  "Recovery remains unavailable until the server verifies it.": "服务器核验完成前暂不可恢复。",
  "The server found the original reward still reserved and unpaid. You may review recovery of this same reward. Check any saved payment hash first; the claim is rechecked before opening your wallet.": "原奖励仍处于预留且未付款状态，可以审阅同一笔奖励的恢复操作。请先检查已保存的付款哈希；打开钱包前会再次核验。",
  "The original reward is already paid onchain. Supply its actual payment transaction hash to restore the verified record. Another claim is unavailable.": "原奖励已在链上付款。请提供实际付款哈希以恢复核验记录，不能再次领取。",
  "The original reward has expired. Ask a reviewer to verify the expiry and release its accounting budget; no new reward is created.": "原奖励已过期。请审核员核验到期情况并释放账面预算，不会创建新奖励。",
  "The original reservation is absent onchain. A reviewer must inspect its history; this page cannot create a replacement reservation.": "链上未发现原始预留，需要审核员检查历史，此页面不能创建替代预留。",
  "Recovery is unavailable until the server can verify an active, funded and unpaid reservation. Recheck the payment or try again after the reported condition is resolved.": "确认预留有效、资金到位且未付款前暂不可恢复。请重新核验付款，或在问题解决后重试。",
  "Receipt under review": "审核中的小票",
  "READ-ONLY EXAMPLE": "只读示例",
  "Purchase": "消费",
  "Reward budget": "奖励预算",
  "USD accounting value": "美元账面金额",
  "Reward ticker": "奖励股票代码",
  "Pending configuration": "等待配置",
  "Receipt checks": "小票核验",
  "Automatic checks": "自动核验",
  "Exception review": "异常复核",
  "Reviewed": "已审核",
  "Check history pending": "等待核验记录",
  "Review note": "审核备注",
  "View recorded payment transaction ↗": "查看已记录的付款交易 ↗",
  "The private receipt image is unavailable. The record remains below.": "私密小票图片暂不可用，下方记录仍然保留。",
  "Allocated token quantity": "已分配的代币数量",
  "Reward asset": "奖励资产",
  "This quantity was allocated from tokens received in a verified purchase. The original dollar budget is unchanged. Allocation is not a payment to your wallet; a funded reward reservation and verified claim are still required.": "此数量来自已核验采购的实际到账代币，原美元预算不变。分配不代表已向钱包付款，仍需建立资金到位的奖励预留并核验领取。",
  "View the purchase fill ↗": "查看采购成交 ↗",
  "View the return to the reward Vault ↗": "查看退回奖励金库的交易 ↗",
  "The token quantity has not been fixed. The dollar reward budget is not a token amount.": "代币数量尚未确定，美元奖励预算不等于代币数量。",
  "Token quantity": "代币数量",
  "See exact atomic amount below": "精确最小单位数量见下方",
  "Exact atomic amount": "精确最小单位数量",
  "Manual conversion price": "人工换算价格",
  "per token": "每枚代币",
  "Price timestamp": "价格记录时间",
  "Not supplied": "未提供",
  "Quote validity": "报价有效期",
  "This quantity uses an administrator-supplied manual price snapshot, not an independently verified or official market quote. The snapshot records the calculation used for this reservation; it does not update with current prices.": "此数量使用管理员提供的人工价格快照，不是独立核验或官方行情。快照记录此次预留的计算依据，不随当前价格更新。",
  "The administrator specified this quantity in atomic units. No market price conversion is asserted.": "此数量由管理员以最小单位填写，不代表已进行市场价格换算。",
  "Token symbols do not establish stock ownership or issuer rights.": "代币符号不能证明股票所有权或发行方权利。",
  "Please provide a short explanation for the reviewer.": "请向审核员简要说明情况。",
  "Sending review request…": "正在发送复核申请…",
  "Your request was saved for review. It does not create a payout.": "复核申请已保存，不会自动产生付款。",
  "Checking reservation…": "正在检查预留…",
  "The prepared call does not match this receipt’s claim. No transaction was sent.": "准备的调用与此小票领取不符，未发送交易。",
  "Claim this reserved reward": "领取这笔已预留奖励",
  "The server verified that this original reservation is currently active and unpaid. Review the same reward and recipient below; no additional reward is created.": "服务器已确认原预留仍有效且未付款。请核对下方同一笔奖励及接收方，不会额外创建奖励。",
  "Review the network, Vault, asset and quantity before opening your wallet.": "打开钱包前请核对网络、金库、资产和数量。",
  "The claim state changed. Review the transaction again before signing.": "领取状态已变化，请重新审阅交易后再签名。",
  "Enter the complete transaction hash from your wallet.": "请输入钱包中的完整交易哈希。",
  "Verifying onchain delivery…": "正在核验链上到账…",
  "Checking transaction…": "正在检查交易…",
  "Delivery verified: the configured Vault paid the expected asset to the fixed recipient.": "到账已验证：配置的金库已将预期资产转入固定接收方。",
  "The supplied transaction was verified as this receipt’s actual payment.": "此交易已核验为该小票的实际付款。",
  "The server did not confirm this transaction as a paid reward. Keep the hash and check again before taking another action.": "服务器尚未确认此交易为已付款奖励，请保留哈希并再次核验后再进行其他操作。",
  "This hash has not been accepted as a verified payment. If your wallet replaced it, paste the new hash. A pending, reverted or cancelled transaction must not be counted as paid.": "此哈希尚未通过付款核验。若钱包替换了交易，请粘贴新哈希。待处理、回滚或已取消的交易不能算作已付款。",
  "Your wallet session expired. Verify again to recheck the saved transaction.": "钱包会话已过期，请重新验证后核验已保存的交易。",
  "Enter a full 66-character transaction hash beginning with 0x.": "请输入以 0x 开头、共 66 个字符的完整交易哈希。",
  "Only this browser reference was cleared. The blockchain transaction was not cancelled. Check your wallet before preparing another claim.": "仅清除了浏览器记录，链上交易没有取消。准备再次领取前请先检查钱包。",
  "Rechecking recorded payment…": "正在重新核验付款记录…",
  "The recorded transaction was verified again against the current chain.": "已依据当前链上状态重新验证该交易。",
  "The recorded hash is not currently verified as this receipt’s payment.": "该哈希目前未被核验为此小票的付款。",
  "The recorded payment was verified again against the chain.": "已依据链上状态重新验证付款记录。",
  "The chain could not be checked right now. Payment remains unconfirmed for this recheck; no new claim or budget release is authorized.": "暂时无法查询链上状态。此次复核未确认付款，也未授权新领取或预算释放。",
  "This link is expired. Create a new link.": "链接已过期，请创建新链接。",
  "Private link copied. Share it only with your own phone.": "私密链接已复制，请仅发送到你自己的手机。",
  "Clipboard access is unavailable. Select and copy the link above.": "无法访问剪贴板，请手动选择并复制上方链接。",
  "Creating…": "正在创建…",
  "Opening wallet…": "正在打开钱包…",
  "Wallet ·": "钱包 ·",
  "Connect your wallet to request a current BSC quote. A separate review shows the 1% fee and minimum received.": "连接钱包即可获取当前 BSC 报价。确认页会单独显示 1% 服务费和最低到账量。",
  "Exchange is not available yet. Once enabled, connect your wallet to see a current BSC quote before confirming.": "兑换尚未启用。启用后请连接钱包，查看当前 BSC 报价后再确认。",
  "Example records only. This page does not connect a wallet, upload a receipt or send a transaction.": "仅为示例记录，此页面不连接钱包、不上传小票，也不发送交易。",
  "Delivery is enabled only for configured assets with a verified, funded reservation. A recorded reward is not yet a payment.": "只有已配置资产且资金到位的预留才能发放。奖励记录不代表已经付款。",
  "No stock delivery is configured. Approved receipts reserve an accounting budget; they are not delivered shares or withdrawable money.": "股票发放尚未配置。批准小票只预留账面预算，不代表股票已到账或可提取现金。",
  "No additional brands are scheduled.": "暂无其他计划上线的品牌。",
  "Selected receipt mappings from this server. USD receipts only; a brand listing is not a payout or a live price.": "这是服务器选择的小票匹配范围，仅支持美元小票。品牌条目不代表已付款或实时报价。",
  "The project token address is not configured. Wallet history and the read-only example remain available; scanner creation and new claims are paused.": "项目代币地址尚未配置。钱包历史和只读示例仍可查看，创建扫码链接和新领取暂时关闭。",
  "Scanning is currently disabled. Wallet history and the read-only example remain available.": "扫码暂未启用，钱包历史和只读示例仍可查看。",
  "Clear, eligible receipts can pass automatic checks and reserve their budget. Incomplete or inconsistent evidence enters exception review. Approval does not mean an asset has been delivered.": "清晰且符合条件的小票可通过自动核验并预留预算；证据不完整或不一致时进入异常复核。批准不代表资产已到账。",
  "Automatic receipt decisions are currently disabled on this server. Receipts await exception review before a budget can be reserved.": "服务器当前未启用自动决定，小票需完成复核后才能预留预算。",
  "Back to your wallet →": "返回钱包 →",
  "Server unavailable": "服务器暂不可用",
  "The brand list could not be loaded. These four example mappings are not a verified current eligibility list. Reload to retry.": "无法加载品牌列表。这四项仅为示例，不代表当前实际资格范围，请刷新重试。",
  "The server configuration could not be verified. Wallet and reward actions remain unavailable.": "无法核验服务器配置，钱包和奖励操作暂不可用。",
  "The current review policy could not be verified. Retry the connection to load it.": "无法核验当前审核规则，请重新连接后加载。",
  "The later-stage brand list is unavailable until the server responds.": "服务器响应前暂时无法加载后续品牌。",
  "The exchange policy could not be loaded. Retry the connection to check it again.": "无法加载兑换规则，请重新连接后查询。",
  "You appear to be offline. Displayed records may be stale; saved transaction references can be checked when connectivity returns.": "当前似乎处于离线状态。显示的记录可能已过时，连接恢复后可核验已保存的交易。",
  "APPLE STORE": "苹果商店",
  "JUNE 29, 2007": "2007 年 6 月 29 日",
  "launch-day close": "上市当日收盘价",
  "JUNE 22, 2012": "2012 年 6 月 22 日",
  "first-delivery close": "首批交付日收盘价",
  "2007 · YEAR-END": "2007 年 · 年末",
  "Dec 31 close": "12 月 31 日收盘价",
  "PAST DUE": "往日小票",
  "THEN ·": "当时 ·",
  "SAMPLE · SEP 4, 2026": "示例价格 · 2026 年 9 月 4 日",
  "VALUE AT SEP 4, 2026": "2026 年 9 月 4 日的示例价值",
  "SHOULD HAVE KEPT IT": "早知道就留着了",
  "brands match. USD reward illustration; token quantity pending procurement.": "个品牌符合搜索条件。此为美元奖励示例，代币数量取决于实际采购。",
  "No matching merchant. Try another name, ticker or category.": "未找到对应商户，请尝试其他名称、股票代码或分类。",
  "example mappings": "项匹配示例",
  "selected receipt brands": "个已选择的小票品牌",
  "· delivery pending": "",
  "The server brand list is unavailable. Apple, Amazon, Costco and GameStop are static examples; use the directory to explore their matching scope. USD receipts only; reward delivery is not live.": "品牌列表暂不可用。苹果、亚马逊、开市客和游戏驿站为静态示例，可在目录中查看匹配范围。仅支持美元小票，奖励发放尚未上线。",
  "This local BSC implementation has": "本地 BSC 版本已选择",
  "selected receipt brands. The searchable brand directory above lists each merchant, matching ticker and purchase scope. USD receipts only. A listing or a past quote does not mean stock delivery is live.": "个小票品牌。上方可搜索各商户、对应股票代码和消费范围。仅支持美元小票，品牌条目或历史报价不代表股票发放已上线。",
  "QUALIFIED WALLET": "符合持仓条件",
  "BELOW MINIMUM": "低于持仓门槛",
  "· HOLDING EXAMPLE": "· 持仓示例",
  "CHOOSE A BRAND": "选择品牌",
  "First": "首次",
  "Not eligible": "不符合条件",
  "token quantity pending actual procurement": "代币数量取决于实际采购",
  "Select a receipt brand to see its matching ticker": "选择小票品牌以查看对应股票代码",
  "Below": "低于",
  "$RECEIPT, new submissions and claims are unavailable. Existing receipt and reward records remain accessible. This calculator does not check a wallet.": "枚 $收据 时不能新提交或领取，已有小票与奖励记录仍可查看。此计算器不查询钱包。",
  "Standard reward: 3% of": "常规奖励：消费金额的 3%，消费金额为",
  ", capped at": "，上限为",
  "for a qualified wallet. First receipt separately:": "，适用于达到持仓门槛的钱包。首张小票单独计算：",
  ", including the first": "，其中前",
  "matched. USD receipts only. Holding is checked before submission and claiming. This is an accounting illustration; token quantity and delivery depend on actual procurement.": "全额匹配。仅支持美元小票，提交及领取前会检查持仓。此为记账示例，代币数量和发放取决于实际采购。",
  "Loading the selected receipt brands. Four example mappings remain visible until the server responds.": "正在加载已选择的品牌。服务器响应前显示四项匹配示例。",
  "Brand configuration unavailable": "品牌配置暂不可用",
  "At least": "至少",
  "tokens · eligible": "枚代币 · 符合条件",
  "Brand configuration is incomplete": "品牌配置不完整",
  "Selected receipt mappings from this server. Matching is subject to review; stock delivery is pending launch.": "这是服务器选择的小票匹配范围。匹配结果需要审核。",
  "Could not load the current brand list. The four mappings shown are examples, not verified current eligibility. Reload this page to retry.": "无法加载当前品牌列表。显示的四项为示例，不代表当前实际资格范围，请刷新重试。",
  "COSTCO WHOLESALE": "开市客",
  "WAREHOUSE #1042 · 10:14 AM": "1042 号门店 · 上午 10:14",
  "Kirkland paper towels": "科克兰厨房纸",
  "Rotisserie chicken": "烤鸡",
  "Organic eggs, 24 ct": "有机鸡蛋 · 24 枚",
  "Salmon fillet": "三文鱼片",
  "FIFTH AVENUE · 11:06 AM": "第五大道 · 上午 11:06",
  "WHOLE FOODS MARKET": "全食超市",
  "UNION SQUARE · 6:05 PM": "联合广场 · 下午 6:05",
  "Groceries": "日用品",
  "STORE #2231 · 4:05 PM": "2231 号门店 · 下午 4:05",
  "Wireless controller": "无线手柄",
  "Reduced motion enabled": "已减少动态效果",
  "Pause animations": "暂停动画",
  "Resume animations": "继续动画",
  "Tax": "税费",
  "1M HOLDING EXAMPLE · MAX $20": "持有 1M 示例 · 最高 20 美元",
  "1M HOLDING EXAMPLE · 3%": "持有 1M 示例 · 3%",
  "+$0.00 for": "+$0.00 对应",
  "quantity pending actual procurement": "数量取决于实际采购",
  "Image": "图片",
  "— unavailable": "— 暂不可用",
  "Apple Store": "苹果商店",
  "Shopping": "购物",
  "Direct Apple purchases with a USD receipt.": "苹果直接消费，需提供美元小票。",
  "Whole Foods": "全食超市",
  "Amazon or Whole Foods purchases with a USD receipt.": "亚马逊或全食超市消费，需提供美元小票。",
  "Costco Wholesale": "开市客",
  "Retail": "零售",
  "Costco purchases with a USD receipt.": "开市客消费，需提供美元小票。",
  "GameStop purchases with a USD receipt.": "游戏驿站消费，需提供美元小票。",
  "Matching merchant on a USD receipt; eligibility remains subject to review.": "美元小票上的商户须匹配，资格仍需审核。",
  "Receipt matching · delivery pending": "小票匹配",
  "No matching brand. Try a merchant name, ticker or another category.": "未找到匹配品牌，请尝试商户名、股票代码或其他分类。",
  "No receipt brands are configured. Please check again later.": "暂未配置小票品牌，请稍后查看。",
  "Qualified wallet": "符合持仓条件的钱包",
  "Below minimum": "低于持仓门槛",
  "Not verified": "尚未验证",
  "Your BSC token balance has not been verified. Check eligibility before submitting or claiming.": "尚未验证你的 BSC 代币余额，请先检查资格再提交或领取。",
  "The project token address is not configured yet. New submissions and claims are unavailable. Your receipt history and recorded rewards remain available.": "项目代币地址尚未配置，暂不可新提交或领取。小票历史和奖励记录仍可查看。",
  "Your BSC balance could not be verified right now. Retry the balance check before submitting or claiming. Existing receipt and payment records are preserved.": "暂时无法验证 BSC 余额，请重新检查后再提交或领取。已有小票及付款记录会保留。",
  "Hold at least": "至少持有",
  "$RECEIPT in this wallet to submit receipts or claim rewards. Your saved receipts and reserved rewards remain in your history.": "枚 $收据 才能提交小票或领取奖励。已保存的小票及预留奖励仍保留在历史中。",
  "eligibility verified. Keep at least": "资格已验证，请至少保留",
  "$RECEIPT in this wallet; your balance is checked again before each submission and claim.": "枚 $收据，每次提交或领取前都会再次检查余额。",
  "Verify your wallet to check its BSC balance. At least 1,000,000 $RECEIPT is required to submit or claim.": "验证钱包以查询 BSC 余额。提交或领取需至少持有 1,000,000 枚 $收据。",
  "CHECKING ELIGIBILITY": "正在检查资格",
  "Reading your current BSC token balance. Your receipt history remains available while this check runs.": "正在读取当前 BSC 代币余额，检查期间仍可查看小票历史。",
  "· ELIGIBLE": "· 符合条件",
  "TOKEN ADDRESS NEEDED": "需要配置代币地址",
  "BELOW THE MINIMUM": "低于持仓门槛",
  "BALANCE CHECK UNAVAILABLE": "持仓检查暂不可用",
  "Wallet balance": "钱包余额",
  "Balance checked": "余额检查时间",
  "The code was not accepted. Request a fresh code and retry.": "验证码未通过，请获取新验证码后重试。",
  "Email sign-in could not finish. Check the code, your connection and this application’s allowed domains. Your wallet has not been replaced.": "邮箱登录未完成，请检查验证码、网络连接和应用允许的域名。你的钱包没有被替换。",
  "Resend in": "重新发送倒计时：",
  "Check your email for the sign-in code.": "请到邮箱查看登录验证码。",
  "No embedded wallet": "未找到内嵌钱包",
  "Email verified. Confirm wallet ownership to finish signing in.": "邮箱已验证，请确认钱包归属以完成登录。",
  "Email wallet verified on BSC.": "BSC 邮箱钱包已验证。",
  "Finish email verification first.": "请先完成邮箱验证。",
  "Server session closed. Email-provider logout needs a retry.": "服务器会话已关闭，邮箱服务的退出操作需要重试。",
  "RECEIPT — Buy the product. Preview the reward.": "RECEIPT — 日常消费，遇见奖励",
  "Skip to how it works": "跳转到使用方法",
  "BSC · local preview": "",
  "How it works": "使用方法",
  "The math": "奖励计算",
  "Eligibility": "参与资格",
  "Rules": "规则",
  "Scanner": "扫码",
  "View read-only reward preview": "官方 X，链接稍后公布",
  "Preview ↗": "X",
  "Scan a receipt": "扫描小票",
  "Costco · Warehouse #1042": "开市客 · 1042 号门店",
  "Buy the": "买下",
  "Get a piece of": "收下一份",
  "Your everyday receipts, with a little more possibility. Hold 1M $RECEIPT and turn an eligible purchase into a stock reward reservation on BSC.": "让日常小票，多一份可能。持有 1M 枚 $收据，将符合条件的消费转为 BSC 上的股票代币奖励预留。",
  "Token minimum": "最低持仓",
  "Launch brands": "首批品牌",
  "One chain": "统一网络",
  "Local preview · stock delivery is not live": "股票发放",
  "Illustration of a receipt and a possible reward; no delivery": "小票与奖励示意",
  "1M HOLDING · EXAMPLE": "持有 1M · 示例",
  "APPLE → AAPL": "苹果 → AAPL",
  "REWARD EXAMPLE 3%": "奖励示例 3%",
  "+$0.00 for AAPL": "+$0.00 对应 AAPL",
  "Token quantity pending actual procurement": "代币数量取决于实际采购",
  "ILLUSTRATION · NOT DELIVERED": "仅为示意 · 未到账",
  "THANK YOU": "谢谢惠顾",
  "Illustrative brand and stock examples": "品牌与股票奖励示例",
  "Apple example": "苹果示例",
  "Amazon example": "亚马逊示例",
  "Costco example": "开市客示例",
  "GameStop example": "游戏驿站示例",
  "What you buy and an illustrative reward": "消费与奖励示例",
  "What you buy": "你的消费",
  "What you own": "对应的奖励",
  "A shopping cart in a warehouse store": "仓储商店中的购物车",
  "Costco run": "逛一趟开市客",
  "$5.59 in COST": "$5.59 对应 COST",
  "Illustrative Apple receipt for a charging cable, 19 US dollars": "苹果充电线美元小票示意，金额 19 美元",
  "ILLUSTRATIVE USD RECEIPT": "美元小票示意",
  "Charging cable": "充电线",
  "EXAMPLE TOTAL": "示例总额",
  "THANK YOU · NO ACTUAL PURCHASE": "谢谢惠顾 · 非真实消费",
  "$0.57 reward example": "$0.57 奖励示例",
  "A white game console and controller": "白色游戏主机和手柄",
  "New controller": "新手柄",
  "$2.09 in GME": "$2.09 对应 GME",
  "A produce aisle": "超市生鲜区",
  "Grocery haul": "日常采购",
  "$3.84 in AMZN": "$3.84 对应 AMZN",
  "Wireless earbuds in their case": "充电盒中的无线耳机",
  "$7.47 in AAPL": "$7.47 对应 AAPL",
  "A phone on a desk": "桌面上的手机",
  "New phone": "新手机",
  "$20.00 in AAPL": "$20.00 对应 AAPL",
  "Illustrative. 3% of the receipt, up to $20 for a wallet holding at least 1M $RECEIPT. Your first receipt also pays its first $5 in full, once. Three receipts a day. Brands are references, not partners.": "仅为示例。持有至少 1M 枚 $收据 时，常规奖励为小票金额的 3%，最高 20 美元。首张小票的前 5 美元另按全额匹配计算，每个钱包仅一次。每天最多三张，品牌仅供匹配参考，不代表合作关系。",
  "Receipt brand examples · delivery pending": "小票品牌",
  "Find the brand on your receipt and its matching ticker. USD receipts only; read each purchase scope before submitting. Receipt matching is subject to review. Token procurement and reward delivery are pending launch.": "查找小票上的品牌及对应股票代码。提交前请阅读各品牌的消费范围。匹配结果需要审核。",
  "Starbucks, SBUX, groceries…": "星巴克、SBUX、日常采购…",
  "Selected receipt brands": "已选择的小票品牌",
  "Loading the server's selected brands. The four mappings above are examples.": "正在加载服务器选择的品牌，上方四项仅为示例。",
  "Sample reward feed": "奖励动态示例",
  "Sample rewards": "奖励示例",
  "→ SAMPLE": "→ 示例",
  "$0.57 for AAPL": "$0.57 对应 AAPL",
  "$5.00 in AMZN": "$5.00 对应 AMZN",
  "WHOLE FOODS": "全食超市",
  "$5.00 in GME": "$5.00 对应 GME",
  "Three steps.": "简单三步，",
  "Under a minute.": "轻松开始。",
  "Photograph the paper you were about to throw away. Automatic checks can approve clear, eligible receipts and reserve their budget; uncertain receipts enter exception review.": "拍下原本准备丢掉的小票。清晰且符合条件的小票可通过自动核验并预留预算，不确定的小票进入异常复核。",
  "Photograph it": "拍下小票",
  "Open the app on your phone and shoot the paper receipt. Camera only — no screenshots, no camera roll.": "在手机上打开应用，使用实时相机拍摄纸质小票，不支持截图或相册导入。",
  "A shopper holding a phone and a paper receipt at a checkout": "结账时手持手机和纸质小票的顾客",
  "Snap": "拍摄",
  "We read it": "识别与核验",
  "The scanner checks the merchant, date and total. High-confidence receipts can pass automatically; exceptions enter review. Holding, duplicate and budget checks still apply.": "系统核对商户、日期和总额。高置信度的小票可自动通过，异常情况进入复核，仍需满足持仓、去重及预算条件。",
  "A payment terminal printing a long paper receipt": "正在打印长小票的收款终端",
  "Verify": "核验",
  "A reward is reserved": "预留奖励",
  "An approved receipt can reserve a reward. No stock issuer is connected to this local BSC build; only verified, funded assets can become claimable.": "通过审核的小票可以预留奖励。本地 BSC 版本尚未完成股票发行方对接；只有资金到位且已验证的资产才能开放领取。",
  "Hands holding a fan of US dollar bills": "手持展开的美元纸币",
  "Own": "领取",
  "What a purchase pays you back": "看看消费对应的奖励",
  "Apple Store · AirPods Max": "苹果商店 · AirPods Max",
  "Buy the AirPods Max.": "买一副 AirPods Max，",
  "Own a bit of": "攒一份",
  "Snap the receipt at checkout. The example below previews a reward denominated in AAPL; it is not a delivered asset.": "结账后拍下小票。下方展示对应 AAPL 的奖励计算示例，不代表资产已到账。",
  "White AirPods Max headphones on a white background": "白色背景上的白色 AirPods Max 耳机",
  "Reward math for AirPods Max": "AirPods Max 奖励计算示例",
  "REWARD 3%": "奖励 3%",
  "+$17.91 in AAPL": "+$17.91 对应 AAPL",
  "How we know it's real": "如何核验真实消费",
  "No upload button.": "实时拍摄，",
  "No second chances.": "一次消费一次奖励。",
  "Real receipts matter. Camera capture, duplicate checks and automatic policy checks help reduce abuse; a camera image alone cannot prove a purchase is authentic.": "真实小票很重要。相机拍摄、去重和自动规则核验有助于减少滥用，但仅凭照片不能证明消费真实发生。",
  "Live camera only.": "仅限实时拍摄。",
  "Use the live camera on your phone. Review the photo before submitting it. Capture metadata is a useful hint, not proof that a receipt is genuine.": "使用手机实时相机，提交前检查照片。拍摄元数据可作为辅助线索，但不能证明小票真实。",
  "Read. Checked. Reviewed if needed.": "先识别，再核验，必要时复核。",
  "Clear receipts can pass automatic checks. Low-confidence, disputed or inconsistent receipts enter exception review before any budget is reserved.": "清晰的小票可通过自动核验。置信度低、有争议或信息不一致时，先进入异常复核，再决定是否预留预算。",
  "One purchase. One reward.": "一次消费，一份奖励。",
  "A purchase fingerprint helps prevent duplicate rewards across wallets. Daily limits and available budget still apply. The $5 welcome reward is once per wallet.": "消费指纹有助于防止跨钱包重复奖励，仍受每日额度和可用预算限制。首张小票的 5 美元匹配每个钱包仅享一次。",
  "Try the scanner": "试试扫码",
  "Local BSC build · rewards subject to review": "本地 BSC 版本 · 奖励需经审核",
  "The oldest regret in tech": "关于那些曾经的消费",
  "The receipts you wish you'd": "那些让你想留下的",
  "Everyone has done this math once. Here it is, on the receipts.": "也许你也算过这笔账，这次把它写在小票上。",
  "You can't go back to 2007. Your next eligible receipt can start with a": "时间无法回到 2007 年，但下一张符合条件的小票，可以从",
  "reward reservation": "预留一份奖励开始",
  "Split-adjusted. Prices as of Sep 4, 2026. Illustrative, not advice — past performance predicts nothing. RECEIPT rewards 3% of a receipt, at most $20 under the current local defaults, not the whole purchase.": "历史价格已经拆股调整，日期为 2026 年 9 月 4 日。仅作示例，不构成建议，历史表现不代表未来。当前本地默认奖励为小票金额的 3%，最高 20 美元，并非返还整笔消费。",
  "Your math": "算算你的奖励",
  "Drag it. See what you'd get —": "拖动滑块，看看奖励金额，",
  "and in what.": "以及对应的股票代码。",
  "One holding requirement: at least 1M $RECEIPT to submit and claim. Every qualified wallet follows the same reward rule. Current local defaults are 3%, up to $20 per receipt. The first receipt matches its first $5 and applies 3% to the rest, within the cap. Delivery remains pending launch.": "统一持仓门槛：至少持有 1M 枚 $收据 才能提交或领取。符合条件的钱包适用同一规则。当前本地默认比例为 3%，每张最高 20 美元；首张小票的前 5 美元全额匹配，剩余按 3% 计算，仍受上限限制。发放尚待上线。",
  "What you spent": "消费金额",
  "Receipt total": "小票总额",
  "Your example holding": "示例持仓",
  "Below 1M · not eligible": "低于 1M · 不符合条件",
  "At least 1M · eligible": "至少 1M · 符合条件",
  "Where": "消费品牌",
  "Find a merchant": "查找商户",
  "Merchant, ticker or category": "商户、股票代码或分类",
  "Receipt brand": "小票品牌",
  "Costco → COST": "开市客 → COST",
  "Apple → AAPL": "苹果 → AAPL",
  "Amazon → AMZN": "亚马逊 → AMZN",
  "GameStop → GME": "游戏驿站 → GME",
  "Illustrative USD reward only. Token quantity pending procurement.": "仅为美元奖励示例，代币数量取决于实际采购。",
  "QUALIFIED · 1M HOLDING EXAMPLE": "符合条件 · 持有 1M 示例",
  "RECEIPT TOTAL": "小票总额",
  "3% OF TOTAL": "总额的 3%",
  "FIRST RECEIPT · SEPARATE RULE": "首张小票 · 单独计算",
  "First $5.00 matched": "前 5 美元全额匹配",
  "PER-RECEIPT CAP": "每张小票上限",
  "USD REWARD EXAMPLE": "美元奖励示例",
  "COST token quantity pending actual procurement": "COST 数量取决于实际采购",
  "Holding example only; no wallet balance is checked here. USD receipts must match an eligible merchant. Delivery is pending.": "计算器不查询实际钱包余额。小票须匹配符合条件的商户，实际奖励以审核结果为准。",
  "One requirement.": "一个门槛，",
  "Hold 1M $RECEIPT.": "持有 1M 枚 $收据。",
  "Hold at least 1,000,000 tokens in the same wallet to submit a receipt and claim its reward. Holding more does not change the reward rule or move you ahead in the review queue. Open the rules page for the current limits.": "在同一钱包中持有至少 1,000,000 枚代币，即可在满足其他条件后提交小票和领取奖励。更多持仓不会改变奖励规则或提高审核优先级，当前限制详见规则页。",
  "HOLD AT LEAST 1M $RECEIPT": "至少持有 1M 枚 $收据",
  "1,000,000 TOKENS": "1,000,000 枚代币",
  "SUBMIT + CLAIM": "提交 + 领取",
  "SAME RULE FOR EVERY QUALIFIED WALLET": "符合条件的钱包适用同一规则",
  "Rewards depend on receipt review and available funding. Your history stays available if your balance falls below the minimum.": "奖励取决于小票审核和可用资金。余额低于门槛时，历史记录仍可查看。",
  "See the current reward rules →": "查看当前奖励规则 →",
  "Local preview": "",
  "Your first receipt is already in your": "第一张小票，也许就在你的",
  "Verify your wallet and its 1M minimum holding, then open the secure camera link on your phone. Automatic checks come first; only exceptions need further review.": "验证钱包及 1M 最低持仓后，在手机打开安全相机链接。先自动核验，异常情况再进一步复核。",
  "Live camera · automatic checks · exception review · delivery pending": "实时拍摄 · 自动核验 · 异常复核",
  "Questions": "常见问题",
  "The obvious ones.": "你可能想知道。",
  "Do I really get stock?": "真的能收到股票吗？",
  "Not in this local build. The stock examples are illustrative. A real stock reward needs a verified issuer, eligible region, funded asset and a confirmed transfer to your wallet. None is implied by a reservation.": "本地版本尚不可领取真实股票资产，页面内容为示例。实际奖励需要核实发行方、地区资格、资产资金及钱包到账转账；预留本身不证明这些条件已满足。",
  "What if the brand isn't public?": "如果消费品牌没有上市呢？",
  "Receipt matching follows the selected brand directory and its listed purchase scope. A familiar name or a publicly traded parent company alone does not make a receipt eligible. Only USD receipts within a listed scope can be reviewed; reward delivery remains pending launch.": "小票按已选择的品牌目录及消费范围匹配。熟悉的品牌名或上市母公司本身不能使小票自动符合条件。仅接受目录范围内的美元小票，奖励发放尚待上线。",
  "Where does the money come from?": "奖励资金从哪里来？",
  "The intended model uses a share of token trading fees for rewards. This local build does not collect live fees. Administrative budget entries track accounting only; onchain delivery also requires a funded Vault. Brands do not fund these rewards.": "计划使用部分代币交易税支持奖励。本地版本尚未收取真实交易税，管理员填写的预算仅用于记账，链上发放还需要金库资金到位。奖励并非由消费品牌出资。",
  "Do I need to buy the token?": "需要购买项目代币吗？",
  "Hold at least 1,000,000 $RECEIPT in the submitting wallet. There is one holding threshold; holding more does not create a higher tier. Your balance is checked before submission and again before a claim. Below the minimum, new actions pause while existing receipt and reward records remain available. A holding does not guarantee approval or delivery.": "提交小票的钱包须至少持有 1,000,000 枚 $收据，只有一个持仓门槛，更多持仓不会产生更高档位。提交和领取前都会检查余额；低于门槛时暂停新操作，已有记录仍可查看。持仓不保证审核通过或奖励到账。",
  "What stops people faking receipts?": "怎样减少伪造小票？",
  "Camera capture, global purchase fingerprints, daily limits and automatic policy checks reduce abuse. Clear eligible receipts can pass automatically; uncertain or inconsistent evidence enters exception review. They do not establish perfect authenticity. Three receipts per day, a $4,000 receipt limit, and one welcome reward per wallet apply.": "通过实时相机、全局消费指纹、每日上限和自动规则减少滥用。清晰且符合条件的小票可自动通过，不确定或矛盾的证据进入复核，但不能保证完全识别伪造。每天最多三张，单张消费上限 4,000 美元，每个钱包仅享一次首次奖励。",
  "Is this live?": "现在正式上线了吗？",
  "This is a local BSC implementation. The brand directory loads its selected receipt mappings from the server. While loading, Apple, Amazon, Costco and GameStop are shown as examples. USD receipts only; reward delivery is not live.": "这是本地 BSC 版本，品牌目录从服务器加载。加载期间展示苹果、亚马逊、开市客和游戏驿站示例。仅支持美元小票，股票奖励发放尚未上线。",
  "*** End of roll ***": "*** 本卷结束 ***",
  "Thank you for keeping your receipts · Roll Nº 0001 · Printed 2026": "感谢你保留小票 · 第 0001 卷 · 印于 2026 年",
  "READ-ONLY PREVIEW": "只读预览",
  "RECEIPT is not affiliated with, endorsed by, or partnered with any brand named on this page.": "RECEIPT 与本页提及的品牌没有隶属、背书或合作关系。",
  "This is a local recreation for development. It is not the original Receipt service, and no stock delivery is live. Real stock delivery would require a verified licensed issuer and custodian; availability varies by region and is not guaranteed. Tokenized shares are securities and can lose value. $RECEIPT is a utility token, not an investment in any brand. Historical figures are split-adjusted, dated, and illustrative only; nothing on this page is investment advice. The reward feed is sample data. Crypto assets carry risk, including total loss.": "这是用于开发的本地复刻版本，并非原 RECEIPT 服务，股票发放尚未上线。真实股票发放需要核实持牌发行方和托管方，适用范围因地区而异，且不保证可用。股票代币可能属于证券并存在亏损风险。$收据 为功能代币，不代表对任何消费品牌的投资。历史数据经过拆股调整并注明日期，仅供示意，不构成投资建议。奖励动态为示例数据，加密资产可能损失全部价值。",
  "The embedded wallet origin is not trusted.": "内嵌钱包来源不受信任。",
  "Secure email wallet": "安全邮箱钱包",
  "The secure email wallet did not load. Check connectivity and retry.": "安全邮箱钱包未能加载，请检查网络后重试。",
  "Unexpected wallet message origin.": "钱包消息来源异常。",
  "The secure wallet frame is unavailable.": "安全钱包窗口暂不可用。",
  "The secure email wallet could not load.": "无法加载安全邮箱钱包。",
  "Plan saved · unfunded": "计划已保存 · 未注资",
  "Funding transaction prepared": "注资交易已准备",
  "Order wallet funded": "订单钱包资金已到位",
  "Bounded stock quote saved": "受限股票报价已保存",
  "Order authorization prepared": "订单授权已准备",
  "Order authorized · submission unverified": "订单已授权 · 提交尚未核验",
  "Order submitted · fill unverified": "订单已提交 · 成交尚未核验",
  "Purchase fill verified": "采购成交已验证",
  "Return-to-Vault transaction prepared": "退回金库交易已准备",
  "Purchased tokens returned to Vault": "采购代币已退回金库",
  "Receipt quantities allocated · unpaid": "小票数量已分配 · 未付款",
  "Cancellation prepared · refund unverified": "取消交易已准备 · 退款尚未核验",
  "Batch cancelled · receipt budgets preserved": "批次已取消 · 小票预算保留",
  "Fund this batch order wallet": "向此批次订单钱包注资",
  "Authorize this exact stock order": "授权这笔精确股票订单",
  "Return the purchased assets to the Vault": "将采购资产退回金库",
  "Cancel the order and return available funding": "取消订单并退回可用资金",
  "The exchange implementation or its control settings changed. New purchases are blocked until the route is reviewed.": "交易合约实现或控制设置已变化，重新审核路线前禁止新采购。",
  "The current exchange deployment could not be checked. No new purchase can proceed.": "无法核验当前交易合约部署，暂不可进行新采购。",
  "This batch does not bind the currently reviewed exchange deployment. Review the fixed route before proceeding.": "此批次未绑定当前已审核的交易合约，请先复核固定路线。",
  "This order has no matching current V3 deployment check. Submission is blocked.": "此订单缺少匹配的当前 V3 部署核验，已阻止提交。",
  "The current buy-and-sell quote loss exceeds the configured limit. The order was not submitted.": "当前买卖报价损耗超过配置上限，订单未提交。",
  "A current matching reverse quote is unavailable. The order was not submitted.": "无法取得当前匹配的反向报价，订单未提交。",
  "The reverse quote exceeds the original input. This price inconsistency needs review before submission.": "反向报价超过原始投入，存在价格不一致，请复核后再提交。",
  "The price check expired before submission. Refresh the order and its current quotes.": "提交前价格检查已过期，请刷新订单和当前报价。",
  "Live submission requires a configured check of current buy and sell quotes.": "正式提交需要配置当前买卖报价检查。",
  "Order submission is disabled. Saved attempts remain available for inspection and lookup.": "订单提交未启用，仍可查看和查询已保存的尝试记录。",
  "Official support for this contract maker has not been verified. Order submission is blocked.": "尚未验证官方支持此合约下单方，已阻止订单提交。",
  "No saved submission intent exists. Refresh the batch before preparing one.": "没有已保存的提交意图，请刷新批次后再准备。",
  "The review intent expired. Refresh and prepare a new intent if the stock order is still valid.": "审阅意图已过期。若股票订单仍有效，可刷新后准备新的提交意图。",
  "This intent belongs to a different session or review. Refresh and inspect the saved order.": "此提交意图属于其他会话或审阅，请刷新并核对已保存订单。",
  "Another administrator prepared this intent. Use that wallet or wait until the intent expires.": "此提交意图由其他管理员准备，请使用对应钱包或等待其过期。",
  "Verify the current administrator wallet before continuing.": "请先验证当前管理员钱包。",
  "The saved order changed. Refresh its fixed details before continuing.": "已保存订单发生变化，请刷新并核对固定字段。",
  "The server cannot currently verify the funded order. No order should be submitted.": "服务器无法核实订单资金，暂不应提交订单。",
  "Current chain evidence does not match the saved order. Refresh its authorization and funding evidence.": "当前链上凭据与保存的订单不符，请刷新授权与注资凭据。",
  "Order lookup is unavailable. The previous attempt remains saved; do not submit it again.": "订单查询暂不可用。此前尝试记录已保留，请勿重复提交。",
  "This attempt belongs to a different execution environment. Its saved record remains readable.": "此尝试记录属于其他执行环境，仍可查看保存的记录。",
  "A submission check is already running. Wait for its recorded result.": "正在进行提交检查，请等待结果保存。",
  "The page, wallet or saved order changed during the check. Refresh and review the current intent.": "检查期间页面、钱包或订单发生变化，请刷新并审阅当前提交意图。",
  "This action is unavailable for the current saved state. Refresh or use order lookup.": "当前记录状态不支持此操作，请刷新或查询订单。",
  "The response did not match this batch. Refresh its saved attempt before continuing.": "响应与此批次不符，请刷新已保存的尝试记录。",
  "Missing procurement module container": "采购模块容器缺失",
  "04 · Batched stock purchases": "04 · 批量股票采购",
  "Refresh purchase queue": "刷新采购队列",
  "Checking the purchase configuration…": "正在检查采购配置…",
  "Each batch uses one fixed purchase route and one order wallet. A quote, order submission or token allocation does not mean a receipt has been paid. Existing receipt budgets stay reserved until the separate reward delivery is verified.": "每个批次使用固定采购路线和独立订单钱包。报价、提交订单或分配代币不代表小票已付款；奖励发放单独核验前，原小票预算持续保留。",
  "execution route:": "执行路线：",
  "· BSC block": "· BSC 区块",
  "Buy and sell quote check": "买卖报价检查",
  "Indicative loss using both quote minima": "按两边最低报价计算的示意损耗",
  "% · limit": "% · 上限",
  "Minimum quoted return": "最低报价回收量",
  "settlement-token base units": "结算代币最小单位",
  "Price checked": "价格检查时间",
  "Price check expires": "价格检查到期时间",
  "· expired": "· 已过期",
  "This is a quote snapshot. It excludes BNB conversion and gas, and does not guarantee execution or a later user sale. Submission checks the prices again.": "这是报价快照，不含 BNB 换算和网络费，也不保证实际成交或用户日后卖出。提交前会再次核查价格。",
  "Review fixed order submission": "审阅固定订单提交",
  "Saved attempt": "已保存的尝试记录",
  "Input asset": "输入资产",
  "Fixed input amount": "固定输入数量",
  "base units": "最小单位",
  "Stock asset": "股票资产",
  "Minimum stock output": "最低股票到账量",
  "Maker / funded order wallet": "下单方 / 已注资订单钱包",
  "Stock recipient": "股票接收方",
  "Order hash": "订单哈希",
  "Order expires": "订单到期时间",
  "Review intent expires": "审阅意图到期时间",
  "Prepared by": "准备人",
  "Intent hash": "意图哈希",
  "Saved request hash": "已保存的请求哈希",
  "Submission destination": "提交目标",
  "Prepare a saved review intent first. Preparation does not submit the order.": "请先准备并保存审阅意图。准备不会提交订单。",
  "A confirmation was attempted from this browser. Its result may be unknown. Query the saved order; do not send this intent again.": "此浏览器已尝试确认，结果可能尚不明确。请查询已保存订单，不要再次发送同一提交意图。",
  "This review intent expired. A new intent can be prepared while the authorized stock order remains valid.": "此审阅意图已过期。已授权股票订单仍有效时，可以准备新意图。",
  "This saved intent cannot currently be confirmed by this wallet and configuration. Its fixed details remain readable. Refresh to check readiness.": "当前钱包及配置无法确认此意图，固定详情仍可查看，请刷新检查条件。",
  "Review these fixed amounts, maker, recipient, order hash and expiry before confirming this submission once.": "请核对固定金额、下单方、接收方、订单哈希及到期时间，再确认提交一次。",
  "The order service acknowledged this order. Acceptance is not a verified Fill or a paid reward. Use lookup and separate onchain verification.": "订单服务已接收此订单，但接单不代表成交已验证或奖励已付款。请查询订单并另行核验链上结果。",
  "A submission attempt is recorded as sending. Its final result is pending. Only order lookup is available.": "记录显示正在发送提交请求，最终结果待确认，目前只能查询订单。",
  "Submission has an uncertain result. The attempt remains saved. Only order lookup is available; the order will not be posted again.": "提交结果不明确，尝试记录已保留。目前只能查询订单，不会再次提交。",
  "Last order lookup:": "最近订单查询：",
  "No result": "暂无结果",
  "· service reports": "· 服务报告",
  "Saved submission response:": "已保存的提交响应：",
  "Unknown": "未知",
  "· HTTP": "· HTTP",
  "Order submission": "订单提交",
  "Submission configured · explicit review and confirmation required.": "订单提交已配置，仍需明确审阅和确认。",
  "Order submission is disabled. Saved attempts can still be inspected and queried.": "订单提交未启用，仍可查看及查询已保存的尝试记录。",
  "The saved attempt does not match the displayed batch order. Refresh before continuing.": "已保存的尝试记录与当前批次订单不符，请刷新后继续。",
  "Prepare a new submission intent": "准备新的提交意图",
  "Prepare order submission": "准备订单提交",
  "Confirm order submission": "确认订单提交",
  "Check saved order (GET only)": "查询已保存订单（只读）",
  "Confirmation asks the server to submit this saved order once. It does not broadcast a wallet transaction. Sending, acceptance and lookup results cannot mark receipts paid or release budgets.": "确认后，服务器仅提交一次这笔已保存订单，不会广播钱包交易。发送、接单或查询结果不能将小票标记为已付款，也不能释放预算。",
  "ISOLATED TEST PURCHASES": "隔离测试采购",
  "READ-ONLY PREPARATION": "只读准备",
  "PURCHASE ROUTE NOT CONFIGURED": "采购路线未配置",
  "The route can prepare bounded transactions and verify recorded chain evidence. This desk prepares unsigned transactions. Order submission requires the separate review and confirmation controls below.": "此路线可准备有明确限制的交易并核验链上记录。工作台准备未签名交易；提交订单需要在下方单独审阅和确认。",
  "Batch minimum:": "批次最低金额：",
  "per ticker": "每种股票",
  "Approved receipt demand": "已批准小票的采购需求",
  "Swipe the purchase table to see all columns.": "左右滑动采购表格查看全部列。",
  "Approved receipt demand; scroll horizontally for all columns": "已批准小票的需求，横向滚动查看全部列",
  "Asset": "资产",
  "Receipts": "小票",
  "USD budget": "美元预算",
  "Next step": "下一步",
  "Prepare batch plan": "准备批次计划",
  "Fixed route and quote client required": "需要固定路线和报价服务",
  "more to reach the batch minimum": "即可达到批次最低金额",
  "Read route and save a bounded plan": "读取路线并保存受限计划",
  "No unallocated approved receipts are waiting for a purchase batch.": "暂无尚未分配、等待采购批次的已批准小票。",
  "Purchase batches": "采购批次",
  "· ISOLATED TEST": "· 隔离测试",
  "USD accounting budget": "美元账面预算",
  "Inspect batch and evidence": "查看批次及凭据",
  "No purchase batches have been created.": "尚未创建采购批次。",
  "Reading the fixed route and saving a batch plan…": "正在读取固定路线并保存批次计划…",
  "purchase batch": "采购批次",
  "Close details": "关闭详情",
  "Batch ID": "批次编号",
  "USD receipt budget": "小票美元预算",
  "Fixed funding amount": "固定注资数量",
  "quote-token base units": "计价代币最小单位",
  "Minimum settlement amount": "最低结算数量",
  "Funding / order expiry": "注资 / 订单到期时间",
  "Order wallet": "订单钱包",
  "Not funded": "未注资",
  "Bound order hash": "绑定的订单哈希",
  "Proven stock purchase": "已证明的股票采购量",
  "Proven settlement cost": "已证明的结算成本",
  "Allocated to receipts": "已分配给小票",
  "Rounding remainder": "取整余量",
  "base units held as inventory": "最小单位，作为库存保留",
  "A verified purchase filled before cancellation. The saved cancellation has been retired; continue with settlement and allocation.": "采购已先于取消成交并完成核验。原取消准备已作废，请继续结算及分配。",
  "The last check did not complete (": "上次检查未完成（",
  "). The saved batch and funds remain accounted for. Refresh its evidence before retrying.": "）。批次及资金记账仍然保留，请刷新凭据后重试。",
  "Verified purchase Fill": "已验证的采购成交",
  "Verified return to the Vault": "已验证的退回金库交易",
  "This exact transaction is saved and cannot be replaced with another route, recipient or amount. It is unsigned. This desk does not broadcast it.": "这笔精确交易已保存，不能换成其他路线、接收方或数量。交易尚未签名，本工作台不会广播。",
  "Recheck saved step": "复核已保存步骤",
  "Read and prepare the next step": "读取并准备下一步",
  "Cancel unfunded plan": "取消未注资计划",
  "Prepare cancellation / recovery": "准备取消 / 恢复",
  "Recorded purchase step": "已记录的采购步骤",
  "Stock purchase Fill": "股票采购成交",
  "Executed stock purchase": "已执行的股票采购",
  "· transaction hash": "· 交易哈希",
  "Verify this": "核验此项",
  "Fill": "成交",
  "Use the actual transaction hash after execution. Order-book status alone cannot prove a fill. A matching third-party settlement or cancellation can be imported without preparing another transaction. Verification checks the exact call or Fill, transfers, nonce, recipient and confirmations.": "执行后请使用实际交易哈希，订单簿状态本身不能证明成交。匹配的第三方结算或取消可直接导入，无需准备另一笔交易。核验会检查精确调用或成交事件、转账、编号、接收方及确认数。",
  "Receipt demand remains in this batch until its refund is verified. If the purchase filled first, select Stock purchase Fill above to recover it and retire the unused cancellation.": "退款验证前，小票需求仍归属此批次。若采购先成交，请在上方选择“股票采购成交”恢复记录，并作废未使用的取消准备。",
  "Checking the next saved purchase step…": "正在检查下一项已保存采购步骤…",
  "Checking cancellation and recovery conditions…": "正在检查取消及恢复条件…",
  "Enter a complete transaction hash beginning with 0x.": "请输入以 0x 开头的完整交易哈希。",
  "Verifying purchase evidence onchain…": "正在核验链上采购凭据…",
  "Purchase queue updated": "采购队列已更新",
  "The displayed purchase queue may be stale.": "当前采购队列可能已过时。",
  "Checking authorization and preparing a fixed submission intent…": "正在核验授权并准备固定提交意图…",
  "Confirming this saved order submission once…": "正在确认提交一次已保存订单…",
  "Looking up the saved order. No order will be posted again…": "正在查询已保存订单，不会重复提交…",
  "The view changed during the request. Refresh the saved attempt; no result was applied to another batch.": "请求期间页面已切换，请刷新已保存记录；结果未应用到其他批次。",
  "Fixed submission intent saved. Review the details before pressing Confirm order submission.": "固定提交意图已保存，请审阅详情后再点击“确认订单提交”。",
  "Order lookup recorded. A separate onchain Fill and delivery check is still required.": "订单查询结果已记录，仍需单独核验链上成交及发放。",
  "Submission attempt recorded. Inspect its saved state; a submitted order is not a verified Fill or a paid reward.": "提交尝试已记录，请查看保存的状态。提交订单不代表成交已验证或奖励已付款。",
  "The confirmation will not be retried automatically. Query the saved attempt before taking another action.": "系统不会自动重复确认，请查询已保存记录后再进行其他操作。",
  "The server responded. Refresh the queue to inspect the recorded result.": "服务器已响应，请刷新队列查看记录结果。",
  "Verify an administrator wallet to inspect the purchase queue.": "请验证管理员钱包后查看采购队列。",
  "Enter the complete 66-character transaction hash from your wallet or block explorer.": "请输入钱包或区块浏览器中的完整 66 字符交易哈希。",
  "Automatic checks queued": "自动核验已排队",
  "Waiting to retry automatic checks": "等待重试自动核验",
  "Exception review required": "需要异常复核",
  "Automatic checks passed": "自动核验已通过",
  "Minimum text confidence": "最低文字识别置信度",
  "Minimum photo width": "照片最低宽度",
  "Minimum photo height": "照片最低高度",
  "Minimum contrast": "最低对比度",
  "Minimum sharpness": "最低清晰度",
  "Near-duplicate tolerance": "近似重复容差",
  "Explicit USD required": "需明确标注美元",
  "Receipt number required": "需包含小票编号",
  "Line totals must reconcile": "明细与总额必须一致",
  "Text confidence": "文字识别置信度",
  "Amount checks": "金额核验",
  "Explicit USD found": "已找到明确美元标记",
  "Receipt number": "小票编号",
  "Wallet holding check": "钱包持仓检查",
  "Photo quality": "照片质量",
  "Additional image checks": "其他图像检查",
  "Capture details": "拍摄信息",
  "Minimum token holding": "最低代币持仓",
  "Token balance": "代币余额",
  "Checked at": "检查时间",
  "Passed": "已通过",
  "Reasons": "原因",
  "Source": "来源",
  "No automatic result recorded": "尚未记录自动核验结果",
  "Yes": "是",
  "No": "否",
  "Not available": "暂不可用",
  "See detailed evidence": "查看详细依据",
  "AUTOMATIC CHECKS ENABLED": "自动核验已启用",
  "AUTOMATIC CHECKS DISABLED": "自动核验未启用",
  "Clear, eligible receipts can reserve budget automatically. Exceptions wait for review in submission order.": "清晰且符合条件的小票可自动预留预算，异常情况按提交顺序等待复核。",
  "Automatic receipt decisions are currently disabled. New receipts require exception review.": "自动决定当前未启用，新小票需要异常复核。",
  "A policy pass does not prove a purchase is authentic. Camera metadata and additional image checks cannot establish authenticity on their own. Budget approval does not deliver an asset.": "通过规则检查不证明消费真实。拍摄元数据和其他图像检查不能单独证明真实性，预算批准也不代表资产已到账。",
  "No automatic policy evidence was recorded for this receipt. Its existing history is preserved.": "此小票未记录自动规则依据，原有历史仍保留。",
  "Decision source": "决定来源",
  "Automatic policy checks": "自动规则核验",
  "Reviewer decision": "审核员决定",
  "Awaiting decision": "等待决定",
  "Policy version": "规则版本",
  "Not recorded": "未记录",
  "No exception reason recorded": "未记录异常原因",
  "View the evidence behind this result": "查看此结果的依据",
  "Detailed evidence is not available for this record.": "此记录暂无详细依据。",
  "These checks assess the submitted image and recorded fields. They do not prove the underlying purchase or authorize an asset transfer.": "这些检查评估图片及记录字段，不能证明实际消费，也不授权资产转移。",
  "RECEIPT — The BSC rules": "RECEIPT — BSC 奖励规则",
  "RECEIPT · BNB Smart Chain · the rules": "RECEIPT · BNB 智能链 · 奖励规则",
  "What your receipt earns.": "小票能带来什么，",
  "What happens next.": "接下来会发生什么。",
  "The requirements, limits and review steps in one place. A receipt is checked before a reward is reserved.": "在这里查看要求、额度和审核步骤。小票先核验，再预留奖励。",
  "Delivery needs a confirmed transfer to your wallet.": "实际到账需要确认资产已转入你的钱包。",
  "Loading the current rules from this server…": "正在加载服务器当前规则…",
  "Enable JavaScript to load this server's current rules. No amounts or eligibility are promised while the settings are unavailable.": "请启用 JavaScript 以加载当前规则。配置不可用时，不承诺奖励金额或资格。",
  "Find your brand": "查找消费品牌",
  "Only the selected merchant scopes below are eligible for matching. A product name on another store's receipt does not necessarily qualify. A listing does not promise stock availability.": "只有下方列出的商户及消费范围可参与匹配。其他商店小票上的商品名不一定符合条件，品牌条目不保证股票资产可用。",
  "USD receipts only. Brands are references, not partners. Reward availability depends on funding and the configured BSC asset.": "仅支持美元小票。品牌仅供匹配参考，不代表合作关系。奖励取决于资金和已配置的 BSC 资产。",
  "Before you scan": "拍摄之前",
  "Keep the paper flat and the merchant, date, item amounts and total in frame.": "将小票铺平，完整拍入商户、日期、明细金额和总额。",
  "Receipt requirements": "小票要求",
  "How the reward is calculated": "奖励如何计算",
  "One holding requirement": "统一持仓门槛",
  "Holding requirements apply to the same wallet at submission, approval and claim. An eligible balance does not guarantee an available reward budget.": "提交、批准和领取时都对同一钱包检查持仓。达到门槛不保证有足够奖励预算。",
  "A worked example · $249 first receipt": "计算示例 · 首张小票 249 美元",
  "Illustration under the current rule, before the daily limit and available budget. This is not a purchase or a paid reward.": "按当前规则示意，尚未计入每日额度和可用预算。这不是实际采购或已付款奖励。",
  "Your limits and scanner link": "每日限制与扫码链接",
  "Current server settings": "服务器当前设置",
  "An expired scanner link can be replaced from the app. Keep the link private. Signing out revokes the linked scanner session.": "扫码链接过期后可在应用中重新创建。请保管好链接，退出登录会撤销关联扫码会话。",
  "How review works": "审核如何进行",
  "Checking": "核验中",
  "The receipt is read and checked for the merchant, date, USD amount, item arithmetic and duplicate evidence.": "识别并核验商户、日期、美元金额、明细计算和重复消费依据。",
  "Unclear receipts go to exception review. Temporary funding or balance-check problems can queue a retry.": "不清晰的小票进入异常复核；暂时性的资金或持仓查询问题可排队重试。",
  "Open the receipt details to see the reason.": "打开小票详情查看原因。",
  "You can request another review and explain what needs correcting. A rejection is not a payment.": "你可以申请复核并说明需要更正的内容。拒绝不代表发生付款。",
  "Reserved": "已预留",
  "The receipt passed review and has a budget reservation.": "小票已通过审核并预留预算。",
  "Stock still needs to be obtained, reserved onchain and claimed before delivery can be verified.": "仍需采购股票代币、建立链上预留并领取，才能核验实际到账。",
  "When something needs attention": "遇到问题时",
  "Situation": "情况",
  "Too few project tokens": "项目代币不足",
  "Check your balance in the connected wallet. History remains available below the holding threshold.": "请检查已连接钱包的余额。低于持仓门槛时仍可查看历史。",
  "Duplicate purchase": "重复消费",
  "The same purchase cannot receive a second reward, including from a different wallet.": "同一笔消费不能再次获得奖励，换钱包也不可以。",
  "Unclear or mismatched receipt": "小票不清晰或信息不符",
  "Check the review reason. Retake an unreadable photo or request another review from the receipt details.": "请查看审核原因。照片不清晰时重新拍摄，或在小票详情中申请复核。",
  "Budget unavailable": "预算暂不可用",
  "The receipt may wait for a retry. No stock has been sent.": "小票可能等待重试，尚未发送股票代币。",
  "Transaction pending": "交易待确认",
  "Keep its transaction hash and use the delivery check. A timeout does not mean the transaction failed.": "保留交易哈希并使用到账核验。超时不代表交易失败。",
  "Check its onchain state. Expiry by itself does not prove a refund or release.": "请检查链上状态，过期本身不证明已退款或释放。",
  "Exchanging your stock": "兑换你的股票代币",
  "Separate from receipt rewards and token trading tax": "与小票奖励及代币交易税分别计算",
  "Loading the exchange fee policy…": "正在加载兑换费用规则…",
  "Exchange service fees apply only when you choose to swap through this app. Network gas and market slippage are separate. No fee is charged by this policy for scanning a receipt or claiming a reward.": "仅在你通过本应用主动兑换时收取服务费，网络费和市场滑点另计。此费用不适用于扫码或领取奖励。",
  "From receipt to your wallet": "从小票到钱包",
  "Verify your wallet.": "验证钱包。",
  "Sign a fresh sign-in message for this server and check your BSC token balance.": "签署服务器提供的新登录消息，并检查 BSC 代币余额。",
  "Open the camera link.": "打开相机链接。",
  "Use the private scanner link on your phone to photograph the paper.": "在手机打开私密扫码链接，拍摄纸质小票。",
  "Follow the receipt review.": "跟进小票审核。",
  "See its reason, reserved budget and progress in your receipt history.": "在小票历史中查看原因、预留预算及进度。",
  "Stock is purchased with the rewards treasury.": "奖励金库采购股票代币。",
  "Tax revenue funds bounded purchases. The purchased stock must reach the Vault before it can back a claim.": "交易税收入支持有明确额度限制的采购。采购股票代币到达金库后，才能支持领取。",
  "Review and claim your reward.": "审阅并领取奖励。",
  "The recipient is fixed to your wallet. Delivery is shown only after the BSC transaction and matching asset transfer are verified.": "接收方固定为你的钱包。BSC 交易及对应资产转账验证通过后，才显示已到账。",
  "What the checks establish": "核验能证明什么",
  "Reading a receipt does not prove who made the purchase. Camera capture, image checks and duplicate detection cannot guarantee authentic consumption. We do not verify your payment with a merchant or bank.": "识别小票不能证明由谁消费。相机拍摄、图片检查和去重无法保证消费真实，我们不向商户或银行核验你的支付记录。",
  "Local BSC implementation. Rules shown here come from this server when the page loads; availability and balances are checked again when you act. Tokenized assets have issuer restrictions and market risk. A sample, quote or budget reservation is not a delivered asset.": "本地 BSC 版本。页面加载时从服务器读取规则，操作时再次核验可用状态和余额。股票代币存在发行方限制和市场风险，示例、报价或预算预留不代表资产已到账。",
  "Open your app →": "打开应用 →",
  "Current rule settings are incomplete.": "当前规则设置不完整。",
  "Scanning configured": "扫码已配置",
  "Scanning not enabled": "扫码未启用",
  "Delivery configured; each reward requires chain verification": "发放已配置，每笔奖励需链上核验",
  "Reward delivery not enabled": "奖励发放未启用",
  "· Loaded": "· 加载时间",
  "Merchant matching is subject to review.": "商户匹配结果需审核。",
  "Receipt age": "小票有效期",
  "Within": "不超过",
  "or less": "或以下",
  "US dollars": "美元",
  "Date": "日期",
  "Not in the future": "不能是未来日期",
  "Photo": "照片",
  "Use the live camera": "使用实时相机",
  "Not previously rewarded": "此前未获得奖励",
  "On your first approved receipt, the first": "首张通过审核的小票，前",
  "of the purchase is matched in full; the rest earns": "消费金额全额匹配，剩余部分奖励比例为",
  "Your first approved receipt includes a": "首张通过审核的小票包含额外奖励",
  "Your first approved receipt has a": "首张通过审核的小票最低奖励为",
  "minimum before limits apply.": "，再应用各项上限。",
  "The standard rate is": "常规奖励比例为",
  "Rewards round down to whole cents, then your per-receipt ceiling, daily allowance and available budget apply. Stock quantities are established from verified purchase allocation or an explicitly reviewed asset quote.": "奖励向下取整到美分，再应用单张上限、每日额度和可用预算。股票数量由已验证的采购分配或明确审核的资产报价确定。",
  "The same reward rule applies above the minimum. Holding more does not create another tier or queue priority.": "达到门槛的钱包适用同一奖励规则。更多持仓不会带来更高档位或插队优先级。",
  "Rule amount": "按规则计算的金额",
  "Before daily and budget limits": "应用每日及预算限制前",
  "Approved receipts per day": "每日最多通过小票",
  "Daily reward limit": "每日奖励上限",
  "Daily reset": "每日重置时间",
  "Midnight UTC": "UTC 零点",
  "Welcome reward": "首次奖励",
  "Once per wallet": "每个钱包仅一次",
  "Scanner link": "扫码链接",
  "Up to": "最多",
  "Automatic checks are enabled. Clear receipts can be approved when the holding requirement and available budget also pass. OCR confidence measures readability; it is not a probability that a purchase is genuine.": "自动核验已启用。小票清晰且持仓、预算条件均满足时可获批准。文字识别置信度反映可读性，并非消费真实的概率。",
  "Automatic approval is disabled on this server. Receipts require an authorized reviewer before a budget can be reserved.": "服务器未启用自动批准，小票须经授权审核员处理后才能预留预算。",
  "% of the actual asset received from a swap goes to the service fee recipient. A quote must show your net proceeds and minimum net proceeds after this fee.": "% 的实际兑换到账资产作为服务费。报价须显示扣费后的净到账量和最低净到账量。",
  "Check the exact route and amounts before confirming.": "确认前请核对具体路线和金额。",
  "Exchange execution is not enabled yet.": "兑换尚未启用。",
  "The exchange fee policy is unavailable. Exchange execution is not enabled.": "兑换费用规则暂不可用，兑换未启用。",
  "Current rules could not be loaded. Reload this page before relying on any amounts or eligibility. The app will recheck the server settings when you act.": "无法加载当前规则，请刷新页面后再参考金额或资格条件。实际操作时会重新核验服务器设置。",
  "RECEIPT — Camera": "RECEIPT — 拍摄小票",
  "A paper trail.": "留下一张小票，",
  "Made with your camera.": "从相机开始。",
  "Keep the entire receipt in view. Check the merchant, date and total are readable before sending it for automatic checks. The wallet must hold at least 1,000,000 $RECEIPT.": "请完整拍摄小票，确认商户、日期和总额清晰，再提交自动核验。钱包至少需持有 1,000,000 枚 $收据。",
  "01 · Your private scanner": "01 · 你的私密扫码页面",
  "Checking link…": "正在检查链接…",
  "Checking this link with the server…": "正在向服务器核验此链接…",
  "Check scanner link again": "重新检查扫码链接",
  "Live receipt camera": "小票实时相机",
  "Your receipt photo, ready for review": "待检查的小票照片",
  "Camera access starts only when you choose Open camera.": "只有点击“打开相机”后才会请求相机权限。",
  "Open camera": "打开相机",
  "Take photo": "拍照",
  "Retake": "重新拍摄",
  "Check this receipt": "核验此小票",
  "The submission outcome is unknown. Check the wallet's receipt list before retrying. Your photo stays in this page's memory; it is not saved to browser storage.": "提交结果未知，请检查钱包的小票列表后再重试。照片仅保留在此页面内存中，不写入浏览器存储。",
  "Open wallet records in another tab →": "在新标签页查看钱包记录 →",
  "I checked the records · retry this photo": "已检查记录，重试此照片",
  "Your photo is sent to this application for automatic receipt checks and stored privately. Uncertain results enter exception review. Camera metadata is a hint, not proof of authenticity. A submission does not create a payout.": "照片将发送给本应用自动核验并私密保存，不确定的结果进入异常复核。拍摄元数据只是辅助线索，不证明真实性，提交不会自动产生付款。",
  "02 · Receipt received": "02 · 已收到小票",
  "Scan another receipt": "继续扫描小票",
  "The rules": "规则说明",
  "Rules are loaded from the server; no reward amount is guaranteed.": "规则从服务器加载，奖励金额不作保证。",
  "This private link expires after 15 minutes. If it expires, return to your wallet page and create a new link.": "私密链接 15 分钟后过期。过期后请返回钱包页面创建新链接。",
  "Open wallet page →": "打开钱包页面 →",
  "Loading new scanner link": "正在加载新的扫码链接",
  "The scanner link changed. Checking the new session. An earlier upload may already have reached its wallet records.": "扫码链接已变更，正在检查新会话。此前上传的小票可能已进入对应钱包记录。",
  "This link has expired or was revoked. Create a new scanner link from your verified wallet page.": "链接已过期或撤销，请从已验证的钱包页面创建新链接。",
  "Link expired": "链接已过期",
  "Checking the private link with this server…": "正在向服务器核验私密链接…",
  "The server returned an invalid scanner session. Retry or create a new link.": "服务器返回的扫码会话无效，请重试或创建新链接。",
  "Link verified. The earlier upload still needs checking in the wallet records.": "链接已验证，此前的上传结果仍需在钱包记录中核查。",
  "Link verified. You can submit another receipt within the limits.": "链接已验证，可以在额度内继续提交小票。",
  "Private link verified. Open your camera when ready.": "私密链接已验证，准备好后即可打开相机。",
  "Your photo stays on this page. Recheck after the balance is available.": "照片会保留在此页面，余额可用后请重新检查。",
  "Session needs rechecking": "会话需要重新检查",
  "Your existing photo, if any, stays here. Recheck the link when connected.": "已有照片会保留，网络恢复后请重新检查链接。",
  "Camera permission was not granted. Allow camera access for this site in browser settings, then use Open camera again.": "尚未获得相机权限。请在浏览器设置中允许本站使用相机，再点击“打开相机”。",
  "No camera was found. Open the complete private link on a phone with a camera.": "未找到相机，请在有相机的手机上打开完整私密链接。",
  "Another application may be using the camera. Close it and try again.": "其他应用可能正在使用相机，请关闭后重试。",
  "This camera could not use the requested settings. Try another camera or browser.": "相机不支持请求的设置，请尝试其他相机或浏览器。",
  "Camera access needs HTTPS, or localhost on the same device, and a supported browser. Use a secure phone-accessible link.": "相机需要 HTTPS 或本设备的 localhost，以及支持的浏览器。请使用手机可以访问的安全链接。",
  "Opening camera…": "正在打开相机…",
  "Your browser may ask for camera permission. No audio is requested.": "浏览器可能会请求相机权限，不会请求录音。",
  "Camera access ended. Reopen the camera when ready.": "相机访问已结束，准备好后可重新打开。",
  "Include all four edges, the merchant, date and total. Avoid glare.": "完整拍入四边、商户、日期和总额，注意避免反光。",
  "Your earlier photo is still available.": "之前拍摄的照片仍然保留。",
  "The camera is still starting. Wait a moment and try again.": "相机仍在启动，请稍候再试。",
  "Capturing…": "正在拍摄…",
  "Photo capture is unavailable in this browser.": "当前浏览器无法拍照。",
  "Could not capture this frame. Please retake it.": "无法拍摄此画面，请重新拍照。",
  "Check this photo carefully. Retake if any text is cut off or blurred. Nothing has been uploaded yet.": "请仔细检查照片，文字被截断或模糊时重新拍摄。目前尚未上传。",
  "Checking receipt…": "正在核验小票…",
  "Sending your photo for automatic receipt checks. Keep this page open; no payout is being made.": "正在发送照片进行自动核验，请保持页面打开。此过程不会付款。",
  "The server did not return a receipt ID. Check the wallet records before retrying.": "服务器未返回小票编号，请先查看钱包记录再决定是否重试。",
  "Receipt ID:": "小票编号：",
  "Receipt received. Follow automatic checks or exception review in your wallet history.": "小票已收到，可在钱包历史中跟进自动核验或异常复核。",
  "Check the wallet records before retrying; this page cannot tell whether an earlier submission was saved.": "重试前请检查钱包记录，此页面无法确定此前提交是否已保存。",
  "Camera paused while the page was hidden. Reopen it when ready.": "页面隐藏时相机已暂停，准备好后请重新打开。",
  "You appear to be offline. Keep this page open to retain your photo; recheck the link when connected.": "当前似乎离线。请保持页面打开以保留照片，网络恢复后重新检查链接。",
  "Read-only example": "只读示例",
  "No private session": "没有私密会话",
  "This is a preview. Camera access and submission are disabled.": "这是预览，相机和提交功能未启用。",
  "A private, verified scanner link enables camera capture here.": "使用经过验证的私密扫码链接后，才能在这里打开相机拍摄。",
  "The real scanner reads wallet eligibility, receipt rules and expiry from the server. No sample receipt is submitted.": "实际扫码页面会从服务器读取持仓资格、规则和有效期，预览不会提交示例小票。",
  "Open the complete private scanner link, including the part after #. If a scanner or messaging app removed it, copy the full link from your verified wallet page.": "请打开包含 # 后内容的完整私密链接。若扫码或聊天应用删掉了该部分，请从已验证的钱包页面复制完整链接。",
  "No valid scanner link": "没有有效扫码链接",
  "This brand is coming in a later release. Its receipts are not eligible yet; no reward was reserved.": "此品牌将在后续上线，当前小票尚不符合条件，未预留奖励。",
  "Your wallet session has expired. Verify your wallet again.": "钱包会话已过期，请重新验证钱包。",
  "Verify your wallet to continue.": "请先验证钱包。",
  "This wallet does not have access to this item.": "此钱包无权访问该记录。",
  "This wallet is not a configured reviewer.": "此钱包不在审核名单中。",
  "Scanning is not enabled on this server yet.": "服务器尚未启用扫码。",
  "Scanning is not configured yet. You can still explore the preview.": "扫码尚未配置，你仍可查看预览。",
  "This scanner link has expired. Create a new link from the wallet page.": "扫码链接已过期，请从钱包页面创建新链接。",
  "This scanner link is invalid or expired. Create a new link from the wallet page.": "扫码链接无效或已过期，请从钱包页面重新创建。",
  "The sign-in message expired. Start wallet verification again.": "登录消息已过期，请重新开始钱包验证。",
  "The signature did not match the server message and wallet. Try again.": "签名与服务器消息或钱包不符，请重试。",
  "The signature did not match this wallet. Try again.": "签名与此钱包不符，请重试。",
  "Too many requests. Wait a little before trying again.": "请求过于频繁，请稍后重试。",
  "This purchase has already been submitted. It cannot receive another reward.": "这笔消费已提交，不能再次获得奖励。",
  "This wallet has reached its daily receipt limit.": "此钱包已达到每日小票上限。",
  "The available reward budget is not sufficient. No payout was made.": "可用奖励预算不足，未发生付款。",
  "Reward delivery is not configured. This receipt has not been paid.": "奖励发放尚未配置，此小票未付款。",
  "This reward is not claimable yet. A verified onchain reservation is required.": "此奖励暂不可领取，需要经过验证的链上预留。",
  "No reward Vault is configured. This receipt has not been paid.": "尚未配置奖励金库，此小票未付款。",
  "The transaction is still awaiting sufficient confirmations. You can check again.": "交易仍在等待足够的确认数，可以稍后再次核验。",
  "The transaction needs more confirmations. You can check again.": "交易需要更多确认，可以稍后再次检查。",
  "This transaction is not confirmed yet. Keep its hash and check again; do not assume it failed.": "交易尚未确认，请保留哈希并再次核验，不要直接当作失败。",
  "The transaction reverted and did not deliver this reward. Review its details in your wallet before preparing another claim.": "交易已回滚，未发放此奖励。请先在钱包中查看详情，再准备其他领取操作。",
  "The transaction is not visible to the server yet. It may still be pending or replaced. Check your wallet and retry with the current hash.": "服务器暂未查到此交易，它可能仍在等待确认或已被替换。请检查钱包，并使用当前哈希重试。",
  "This receipt currency is not supported.": "暂不支持此小票币种。",
  "This merchant is not currently supported.": "暂不支持此商户。",
  "The photo is too large. Retake it at a lower resolution.": "照片过大，请降低分辨率后重新拍摄。",
  "The server could not decode this photo. Please retake it.": "服务器无法读取此照片，请重新拍摄。",
  "Hold at least 1,000,000 $RECEIPT in this wallet to submit or claim. Your existing receipts and rewards remain recorded.": "此钱包需至少持有 1,000,000 枚 $收据 才能提交或领取，已有小票与奖励记录仍保留。",
  "The project token address is not configured yet. Submissions and new claims are unavailable; existing records remain readable.": "项目代币地址尚未配置，提交和新领取暂不可用，已有记录仍可查看。",
  "Your BSC token balance could not be checked. Retry the balance check before submitting or claiming.": "无法查询 BSC 代币余额，请重新检查后再提交或领取。",
  "Wallet eligibility could not be verified. Retry the balance check; your existing records are preserved.": "无法验证钱包资格，请重试余额检查，已有记录仍保留。",
  "The request was not accepted (": "请求未获接受（",
  "The wallet request was cancelled. No new transaction hash was received. You can try again when ready.": "钱包请求已取消，未收到新的交易哈希。准备好后可重试。",
  "A request is already open in your wallet. Open it to continue or cancel.": "钱包中已有待处理请求，请打开钱包继续或取消。",
  "The wallet is disconnected. Unlock it and reconnect before continuing.": "钱包已断开，请解锁并重新连接后继续。",
  "The wallet is not connected to the required network. Reconnect on the network shown here.": "钱包未连接到所需网络，请切换到页面显示的网络后重新连接。",
  "The request timed out. Its final status is unknown; refresh before submitting again.": "请求超时，最终状态未知，请刷新核验后再提交。",
  "Could not reach the server. Check the connection and try again.": "无法连接服务器，请检查网络后重试。",
  "The server could not complete this request.": "服务器未能完成此请求。",
  "The server returned an unexpected response. Please retry.": "服务器返回了异常响应，请重试。",
  "Missing page element:": "缺少页面元素：",
  "Received · checking": "已收到 · 正在核验",
  "Automatic checks pending": "等待自动核验",
  "Reservation prepared · not confirmed": "预留已准备 · 尚未确认",
  "Delivery verified": "到账已验证",
  "Payment awaiting recheck": "付款等待复核",
  "Appeal awaiting review": "申诉等待复核",
  "Automatic checks waiting to retry": "自动核验等待重试",
  "Automatically approved · budget reserved": "自动批准 · 预算已预留",
  "Previously paid · chain check unavailable": "曾记录已付款 · 链上检查暂不可用",
  "Previously paid · verification needs refresh": "曾记录已付款 · 需要重新核验",
  "Automatic receipt checks passed and the accounting budget was reserved. Delivery is a separate step.": "自动核验已通过，账面预算已预留。实际发放是独立步骤。",
  "This receipt is waiting for automatic checks.": "此小票正在等待自动核验。",
  "An eligibility or budget check could not finish. Automatic checks will retry; no asset has been sent.": "资格或预算检查未完成，将重试自动核验，目前未发送资产。",
  "Some receipt details need another look. The receipt is waiting for exception review.": "部分小票信息需要进一步检查，正在等待异常复核。",
  "No additional review note.": "暂无其他审核备注。",
  "EXAMPLE ·": "示例 ·",
  "Asset pending": "资产待配置",
  "Your first receipt matches its first $": "首张小票的前 $",
  ", then applies the standard rate to the rest, within the receipt cap.": "全额匹配，其余按常规比例计算，并受单张上限限制。",
  "The first-receipt calculation follows the currently configured welcome rule.": "首张小票按当前配置的首次奖励规则计算。",
  "$RECEIPT to submit or claim. All qualified wallets use the same rule:": "枚 $收据 才能提交或领取。符合条件的钱包适用同一规则：",
  "% per receipt, up to $": "% 的小票金额，最高 $",
  "receipts per day; receipt total at most $": "张 / 天；单张小票总额最高 $",
  ", within": "，有效期为",
  "Daily limits reset at midnight": "每日额度于零点重置，时区为",
  "Wallet changed. Verify the selected wallet to continue.": "钱包已变更，请验证当前选中的钱包。",
  "Your wallet is locked or disconnected. Unlock it and verify again.": "钱包已锁定或断开，请解锁后重新验证。",
  "Network changed. Reconnect on": "网络已变更，请重新连接到",
  "Network changed during verification. Start again on": "验证期间网络发生变化，请重新开始并连接到",
  "The wallet disconnected. Unlock it and reconnect before continuing.": "钱包已断开，请解锁并重新连接后继续。",
  "Your sign-in session expired. Verify your wallet again.": "登录会话已过期，请重新验证钱包。",
  "No wallet connection is available. Open this page in your wallet browser and verify again.": "当前没有可用的钱包连接，请在钱包浏览器中打开此页面并重新验证。",
  "Wallet changed. Verify the selected wallet again.": "钱包已变更，请重新验证当前钱包。",
  "Reconnect your wallet on": "请将钱包重新连接到",
  "Wallet verification must be repeated before continuing.": "继续操作前需要重新验证钱包。",
  "No browser wallet found. Install an EVM wallet or open this page in its browser.": "未找到浏览器钱包，请安装 EVM 钱包或在钱包内置浏览器中打开。",
  "Switch your wallet to": "请将钱包网络切换到",
  "to continue.": "后继续。",
  "Complete the open transaction first.": "请先完成已打开的交易。",
  "Wallet verification is already in progress.": "钱包验证正在进行中。",
  "Wallet connection changed. Start verification again.": "钱包连接发生变化，请重新开始验证。",
  "Opening your wallet…": "正在打开你的钱包…",
  "Select a wallet account to continue.": "请选择钱包账户以继续。",
  "Switch to": "请切换到",
  "if your wallet asks…": "，按钱包提示操作…",
  "Getting a single-use sign-in message from this server…": "正在从服务器获取一次性登录消息…",
  "Wallet changed. Start verification again.": "钱包已变更，请重新开始验证。",
  "Review the sign-in message in your wallet. This signature verifies identity; it is not a transaction.": "请在钱包中审阅登录消息。此签名用于验证身份，不是一笔交易。",
  "Wallet or network changed during verification. Start again.": "验证期间钱包或网络已变更，请重新开始。",
  "Wallet changed. Verify again.": "钱包已变更，请重新验证。",
  "The local view was cleared, but server logout could not be confirmed. Retry disconnect when the server is reachable.": "本地显示已清除，但无法确认服务器已退出登录。服务器恢复后请重试断开连接。",
  "Complete wallet verification first.": "请先完成钱包验证。",
  "A transaction request is already open in your wallet. Complete or cancel it before opening another.": "钱包中已有交易请求，请完成或取消后再打开另一笔。",
  "Verify your wallet before submitting a transaction.": "提交交易前请先验证钱包。",
  "No funded delivery configuration is enabled. No transaction was sent.": "资金发放配置尚未启用，未发送交易。",
  "The proposed transaction does not match the configured network and reward Vault.": "拟定交易与配置的网络或奖励金库不符。",
  "Wallet verification changed. No new transaction request was opened.": "钱包验证状态已变化，未打开新的交易请求。",
  "Wallet locked or changed. Verify again before signing.": "钱包已锁定或变更，请重新验证后再签名。",
  "Wallet locked or changed. No new transaction request was opened.": "钱包已锁定或变更，未打开新的交易请求。",
  "Switch back to": "请切换回",
  "before sending.": "后再发送。",
  "The wallet did not return a valid transaction hash. Check your wallet before retrying.": "钱包未返回有效交易哈希，请检查钱包后再重试。",
  "A wallet request is already in progress.": "钱包请求正在进行中。",
  "Verify your wallet first.": "请先验证你的钱包。",
  "The selected wallet is disconnected.": "当前钱包已断开连接。",
  "Wallet or network changed. No transaction request was opened.": "钱包或网络已变化，未打开交易请求。",
  "No valid transaction hash was returned. Check the wallet before attempting another transfer.": "未返回有效交易哈希，请先检查钱包再尝试其他转账。",
  "Reward Vault": "奖励金库",
  "As shown in the verified reservation": "以已验证预留中的记录为准",
  "Token amount": "代币金额",
  "See reservation": "查看预留记录",
  "Recipient": "接收方",
  "Fixed by the reservation": "由预留固定",
  "Native value sent": "发送的原生币金额",
  "+ network gas": "+ 网络费",
  "Account for quote assets already deposited in this Vault. This transaction does not deposit or withdraw funds.": "登记金库内已存入的计价资产，此交易不会存入或提取资金。",
  "Change the Vault pause state. Review whether operations should be paused or resumed before signing.": "更改金库暂停状态，签名前请确认是暂停还是恢复操作。",
  "Spend the exact quote-token amount through a permitted adapter. The minimum output and deadline protect this purchase; no reward is paid to a user by this operation.": "通过允许的适配器支付精确的计价代币数量，最低到账量和截止时间用于保护采购。本操作不会向用户发放奖励。",
  "No purchase adapter is configured. Asset purchases are unavailable; no alternative route is assumed.": "尚未配置采购适配器，资产采购不可用，也不会自动选择替代路线。",
  "Reading chain…": "正在读取链上状态…",
  "The treasury response is not a verified snapshot of the configured network and Vault.": "金库响应不是配置网络及金库的已验证快照。",
  "Vault": "金库",
  "Network / block": "网络 / 区块",
  "Block time": "区块时间",
  "Operations": "操作状态",
  "Not paused": "未暂停",
  "Quote asset": "计价资产",
  "Accounted quote": "已登记计价资产",
  "Operator": "操作员",
  "Guardian": "守护角色",
  "Verified contract balances · token base units": "已验证的合约余额 · 代币最小单位",
  "Total balance": "总余额",
  "Available": "可用",
  "BNB · native": "BNB · 原生币",
  "Permitted token": "允许的代币",
  "No permitted adapters": "没有允许的适配器",
  "Verified chain snapshot at block": "已验证的链上快照，区块",
  "A previously submitted treasury transaction awaits verification. Check it before submitting another operation.": "此前提交的金库交易等待核验，请先核验再提交其他操作。",
  "The last displayed snapshot may be stale.": "上次显示的快照可能已过时。",
  "Verify the previously submitted operation before preparing another.": "准备其他操作前，请先核验此前提交的交易。",
  "Choose a permitted adapter, a valid asset, positive integer amounts, and a future deadline.": "请选择允许的适配器、有效资产、正整数数量和未来截止时间。",
  "Preparing unsigned transaction…": "正在准备未签名交易…",
  "The prepared transaction does not match the reviewed treasury action. No transaction was sent.": "准备的交易与已审阅的金库操作不符，未发送交易。",
  "New state": "新状态",
  "PAUSE operations": "暂停操作",
  "RESUME operations": "恢复操作",
  "Effect": "操作效果",
  "Account for deposited quote; no funds are deposited by this action": "登记已存入的计价资产，本操作不注资",
  "Adapter": "适配器",
  "Quote spent": "支付的计价资产",
  "Minimum received": "最低到账量",
  "Deadline": "截止时间",
  "Review treasury transaction": "审阅金库交易",
  "Action": "操作",
  "Opening your wallet is a separate action. The prepared operation is not a completed transaction.": "打开钱包是独立操作，准备交易不代表交易已完成。",
  "Unsigned operation prepared. Review the fields, then choose whether to open your wallet.": "未签名操作已准备，请检查字段后再决定是否打开钱包。",
  "The purchase deadline has passed. Prepare a new transaction.": "采购截止时间已过，请准备新交易。",
  "Enter the complete treasury transaction hash.": "请输入完整的金库交易哈希。",
  "Verifying transaction…": "正在核验交易…",
  "The server has not verified this operation as confirmed.": "服务器尚未将此操作核验为已确认。",
  "Treasury transaction verified. The refreshed balances are a separate current chain snapshot.": "金库交易已验证，刷新后的余额为独立的当前链上快照。",
  "Treasury transaction verified, but the balance refresh failed. Read the Vault balances again before acting.": "金库交易已验证，但余额刷新失败，请重新读取余额后再操作。",
  "ON BNB SMART CHAIN": "BNB 智能链",
  "Your wallet": "你的钱包",
  "Current token balances. Receipt allocations are shown separately below. Stock tokens are not brokerage shares.": "当前代币余额，小票分配在下方单独显示。股票代币不等同于券商账户中的股票。",
  "Wallet actions": "钱包操作",
  "Exchange · 1%": "兑换 · 1%",
  "Send": "发送",
  "You pay": "你支付",
  "Amount to exchange": "兑换数量",
  "Maximum slippage": "最大滑点",
  "Get a fresh quote": "获取最新报价",
  "Review exchange": "审阅兑换",
  "BSC recipient address": "BSC 接收地址",
  "Amount": "数量",
  "Max": "全部",
  "Send has no 1% exchange fee. Network gas still applies. BNB Max reserves estimated gas.": "发送不收 1% 兑换服务费，网络费另计。发送全部 BNB 时会预留预计网络费。",
  "Review transfer": "审阅转账",
  "Wallet transaction history": "钱包交易记录",
  "Transfers and exchanges started here. Historical status is rechecked when you open a record.": "在此发起的转账和兑换，打开记录时会重新核验历史状态。",
  "View BSC transaction": "查看 BSC 交易",
  "Verify your selected wallet first.": "请先验证当前钱包。",
  "Quotes use reviewed BSC pools. The service fee is deducted from actual output.": "报价使用已审核的 BSC 池子，服务费从实际到账资产中扣除。",
  "Exchange is not available yet. Check back when trading opens.": "兑换尚未启用，请在开放交易后再查看。",
  "Transfer from your verified wallet to a BSC address.": "从已验证钱包转账至 BSC 地址。",
  "Transfers are not available in this release yet.": "当前版本尚未开放转账。",
  "Checking current BSC balances…": "正在检查当前 BSC 余额…",
  "Some assets unavailable.": "部分资产暂不可用。",
  "· block": "· 区块",
  "Refresh balances to verify this asset before continuing.": "请刷新余额并核验此资产后再继续。",
  "Previously confirmed — recheck": "此前已确认，请重新核验",
  "No wallet transactions started here yet.": "尚未在此发起钱包交易。",
  "Reset token allowance": "重置代币授权额度",
  "Approve this amount": "授权此数量",
  "From": "转出方",
  "Allowance": "授权额度",
  "Pay": "支付",
  "Spender": "授权对象",
  "1% of actual output": "实际到账量的 1%",
  "Fee recipient": "服务费接收方",
  "Maximum estimated gas cost": "预计最高网络费",
  "This approval alone does not exchange tokens. After confirmation, request and review a fresh quote.": "单独授权不会兑换代币。授权确认后，请获取并审阅新报价。",
  "Confirming requests a real transaction from your wallet. Check the address and amount carefully.": "确认后会向钱包请求真实交易，请仔细核对地址和数量。",
  "Rechecking the recorded transaction…": "正在重新核验已记录交易…",
  "Review all details before confirming.": "确认前请审阅全部详情。",
  "Getting a current quote…": "正在获取当前报价…",
  "Before fee": "扣费前",
  "1% service fee": "1% 服务费",
  "Estimated received": "预计到账",
  "Quote valid for 30 seconds. Gas is additional.": "报价最长有效 30 秒，以到期时间为准。网络费另计。",
  "The quote expired. Request a fresh quote.": "报价已过期，请获取新报价。",
  "Max will subtract estimated BNB gas in the review.": "发送全部 BNB 时，会在审阅页扣除预计网络费。",
  "Max uses the current token balance.": "“全部”使用当前代币余额。",
  "Wallet view changed. Check transaction history.": "钱包页面已变化，请查看交易记录。",
  "Transaction request opened. Complete or cancel it in your wallet.": "交易请求已打开，请在钱包中完成或取消。",
  "Check your wallet and this saved action before starting another transaction.": "开始其他交易前，请检查钱包和此操作记录。",
  "Enter the full transaction hash.": "请输入完整交易哈希。",
  "Quote expired. Request a fresh quote before continuing.": "报价已过期，请获取新报价后继续。",
  "This review expired. Prepare a fresh transaction.": "此审阅已过期，请准备新交易。",
  "Enter a plain positive amount without commas or scientific notation.": "请输入普通正数，不要使用逗号或科学计数法。",
  "This asset supports at most": "此资产最多支持",
  "decimal places.": "位小数。",
  "Enter a positive amount within the supported range.": "请输入支持范围内的正数。",
  "The transaction does not match the reviewed wallet action.": "交易与已审阅的钱包操作不符。",
  "Transaction details or maximum network cost changed. Prepare and review again.": "交易详情或最高网络费发生变化，请重新准备并审阅。",
  "A valid wallet address is required.": "需要有效的钱包地址。",
  "A JSON object is required.": "请求需要 JSON 对象。",
  "A 32-byte transaction hash is required.": "需要完整的 32 字节交易哈希。",
  "The server is shutting down. Retry after it restarts.": "服务器正在关闭，请在重启后重试。",
  "Mutation requires the configured same-origin website.": "操作须来自已配置的同源网站。",
  "Cross-site mutations are forbidden.": "不允许跨站修改请求。",
  "Image or request exceeds the configured size limit.": "图片或请求超出大小限制。",
  "Too many requests. Try again later.": "请求过于频繁，请稍后重试。",
  "Invalid request.": "请求无效。",
  "The operation could not be completed. No payment was recorded.": "操作未完成，未记录付款。",
  "Image exceeds the upload size limit.": "图片超过上传大小限制。",
  "Connect and sign in with your wallet.": "请连接钱包并登录。",
  "Wallet session has expired or was revoked.": "钱包会话已过期或撤销。",
  "Wallet changed. Sign in again with the connected account.": "钱包已变更，请使用当前账户重新登录。",
  "Wallet network changed. Switch to the configured chain and sign in again.": "钱包网络已变更，请切换到配置的链并重新登录。",
  "A scan session capability is required.": "需要有效的扫码会话凭据。",
  "Scan link is invalid or expired.": "扫码链接无效或已过期。",
  "Scan link is expired or revoked. Generate a new link from your wallet.": "扫码链接已过期或撤销，请从钱包页面创建新链接。",
  "An authenticated allowlisted administrator is required.": "需要已登录且位于允许名单中的管理员。",
  "Receipt was not found.": "未找到此小票。",
  "This receipt belongs to another wallet.": "此小票属于其他钱包。",
  "Manual quote snapshot was not found.": "未找到人工报价快照。",
  "Reward has no verified asset reservation.": "奖励缺少已验证的资产预留。",
  "Local BSC Test": "本地 BSC 测试",
  "Quotes require current route and contract verification": "报价需要核验当前路线与合约",
  "Exchange settlement configuration pending": "兑换结算尚待配置",
  "Challenge belongs to a different chain.": "登录验证属于另一条链。",
  "Sign-in challenge is expired, already used, or mismatched.": "登录验证已过期、已使用或不匹配。",
  "Wallet signature does not match this challenge.": "钱包签名与此登录验证不符。",
  "Challenge has already been consumed.": "此登录验证已使用。",
  "Receipt processing is busy. Please retry shortly.": "小票处理繁忙，请稍后重试。",
  "Upload exactly one image using the image field.": "请通过图片字段上传一张图片。",
  "Capture metadata must be valid JSON.": "拍摄信息必须为有效 JSON。",
  "Upload one image using the image field.": "请通过图片字段上传一张图片。",
  "Upload a valid single-frame JPEG, PNG or WebP within the pixel limit.": "请上传像素限制内的单帧 JPEG、PNG 或 WebP 图片。",
  "This receipt image has already been submitted.": "此小票图片已提交。",
  "Local OCR could not read this image. Please retry with a clearer image.": "文字识别无法读取此图片，请换一张更清晰的照片重试。",
  "OCR returned an invalid result.": "文字识别返回的结果无效。",
  "This brand is planned for a later release. Its receipts are not eligible yet.": "此品牌计划在后续上线，当前小票尚不符合条件。",
  "The same receipt content has already been submitted.": "相同小票内容已经提交。",
  "This receipt has already been submitted.": "此小票已提交。",
  "You may only read your wallet rewards.": "只能读取当前钱包的奖励。",
  "History page size must be an integer from 1 to 200.": "每页历史条数须为 1 至 200 的整数。",
  "History cursor is invalid.": "历史分页标记无效。",
  "History cursor is invalid or belongs to another wallet.": "历史分页标记无效或属于其他钱包。",
  "Only rejected receipts can be appealed.": "只有未通过的小票才能申请复核。",
  "This receipt already has an appeal.": "此小票已提交复核申请。",
  "Receipt changed. Refresh and retry.": "小票已变更，请刷新后重试。",
  "This image is private.": "此图片为私密图片。",
  "Unknown status filter.": "未知的状态筛选条件。",
  "Retry limit must be 1 to 100.": "重试上限须为 1 至 100。",
  "Reference was already used with a different amount.": "此参考编号已用于另一笔金额。",
  "Decision must be approve or reject.": "请选择批准或拒绝。",
  "Receipt has already been reviewed.": "此小票已经审核。",
  "Create a quote after review approval and before preparing a reservation.": "请在审核批准后、准备预留前创建报价。",
  "No verified reward asset is configured for this ticker.": "此股票代码尚未配置已验证的奖励资产。",
  "The requested quote asset does not match the receipt ticker.": "请求的报价资产与小票股票代码不符。",
  "Quote lifetime must be an integer number of seconds.": "报价有效期须为整数秒。",
  "Reward changed while its quote was being prepared.": "准备报价期间奖励发生变化。",
  "Administrator-supplied manual price; market price is not independently verified.": "管理员提供的人工价格，市场价格未经独立核验。",
  "Token amount is rounded down to the asset atomic unit.": "代币数量向下取整到资产最小单位。",
  "Reward must be approved before preparing a reservation.": "准备预留前须先批准奖励。",
  "The original procurement allocation evidence is required.": "需要原始采购分配凭据。",
  "A procured reward cannot use a replacement manual quote.": "已采购的奖励不能换用人工报价。",
  "Procurement evidence is required.": "需要采购凭据。",
  "The asset and exact token quantity must match the proven procurement allocation.": "资产及精确数量必须与已证明的采购分配一致。",
  "No verified reward asset is configured for this receipt ticker.": "此小票股票代码尚未配置已验证的奖励资产。",
  "Selected asset does not match this receipt ticker.": "所选资产与小票股票代码不符。",
  "Quote must match this exact receipt, reward value, asset and token amount.": "报价必须与此小票、奖励金额、资产及代币数量精确匹配。",
  "Manual price snapshot has expired. Create a fresh quote before preparing the reward.": "人工价格快照已过期，请获取新报价后再准备奖励。",
  "Reservation deadline must be integer Unix seconds.": "预留截止时间须为整数 Unix 秒。",
  "An issued unsigned reservation and its pricing snapshot are immutable. Confirm that exact reservation.": "已出具的未签名预留及价格快照不可修改，请确认原来的精确预留。",
  "This older preparation has no stored transaction snapshot. Confirm its original transaction or use deadline recovery.": "此较早的准备记录未保存交易快照，请确认原交易或使用到期恢复。",
  "Prepared transaction belongs to a different chain or Vault configuration. Restore its original configuration before continuing.": "准备交易属于其他链或金库配置，请恢复原配置后继续。",
  "Original unsigned transaction restored without changing its amount or price snapshot.": "原未签名交易已恢复，金额及价格快照未改变。",
  "The manual quote may now be stale; it records the price used when this transaction was first prepared.": "人工报价可能已过时，此记录保留首次准备交易时的价格。",
  "This restoration is not a new onchain simulation. The Vault still enforces deadline, funding, permissions and one-time reward ID.": "恢复不代表已重新模拟链上交易。金库仍会检查截止时间、资金、权限和奖励编号的一次性限制。",
  "Reservation deadline must be 5 minutes to 30 days in the future.": "预留截止时间须在未来 5 分钟至 30 天之间。",
  "Reward asset decimals changed after the quote was recorded.": "报价记录后奖励资产精度发生变化。",
  "Reward status changed.": "奖励状态已变化。",
  "A different reservation was already prepared.": "已准备过另一笔预留。",
  "Unsigned transaction only. No funds have been sent.": "仅为未签名交易，未发送资金。",
  "Token quantity is fixed to the actual asset received and allocated from its proven procurement batch.": "代币数量固定为已验证采购批次中实际收到并分配的资产数量。",
  "Token amount uses the attached administrator-supplied manual price snapshot. It is not an independently verified market quote.": "代币数量使用所附管理员人工价格快照，不是独立核验的行情报价。",
  "Token amount was explicitly entered in atomic units; no stock-price conversion is asserted.": "代币数量由人工按最小单位填写，不代表已进行股票价格换算。",
  "The accounting budget is separate from verified onchain reserves.": "账面预算与已验证的链上储备分别计算。",
  "Reward must have a prepared reservation.": "奖励需要已有的预留准备记录。",
  "A confirmed onchain reservation is required before claiming.": "领取前须有已确认的链上预留。",
  "Onchain reservation deadline has passed.": "链上预留已超过截止时间。",
  "A confirmed reservation transaction is required.": "需要已确认的预留交易。",
  "An exact prepared reward is required before verifying payment.": "核验付款前需要精确的奖励准备记录。",
  "Only a prepared, confirmed or disputed onchain reservation can be released.": "只有已准备、已确认或存在争议的链上预留才能释放。",
  "Unsigned transaction. Budget is released only after confirmed onchain expiry.": "未签名交易。只有链上到期状态确认后才释放预算。",
  "Only a prepared, confirmed or disputed reservation can expire.": "只有已准备、已确认或存在争议的预留才能作到期处理。",
  "Only an unconfirmed prepared reward or disputed historical payment can use this recovery flow.": "此恢复流程仅适用于未确认的奖励准备或存在争议的历史付款。",
  "Reward status changed during recovery verification.": "恢复核验期间奖励状态已变化。",
  "Treasury reader is unavailable.": "金库读取暂不可用。",
  "paused must be a boolean.": "暂停状态须为是或否。",
  "Purchase adapter is not explicitly configured.": "采购适配器未明确配置。",
  "Purchase asset is not a configured receipt reward asset.": "采购资产不是已配置的小票奖励资产。",
  "Purchase deadline must be within the next 20 minutes.": "采购截止时间须在未来 20 分钟内。",
  "Action must be sync, pause or purchase.": "请选择同步、暂停或采购操作。",
  "Treasury transaction preparation is unavailable.": "金库交易准备暂不可用。",
  "Unsigned transaction only. Review and sign separately in your wallet.": "仅为未签名交易，请在钱包中另行审阅和签名。",
  "The Vault immutable adapter, amount, daily limit and slippage rules were simulated.": "已模拟检查金库固定的适配器、金额、每日上限和滑点规则。",
  "This action does not credit the offchain USD accounting budget.": "此操作不会增加链下美元账面预算。",
  "Prepared treasury action was not found.": "未找到已准备的金库操作。",
  "Only the administrator who prepared this action can confirm it.": "只有准备此操作的管理员才能确认。",
  "Prepared action has already been confirmed with another transaction.": "此准备操作已由另一笔交易确认。",
  "Treasury confirmation is unavailable.": "金库交易确认暂不可用。",
  "Action was confirmed concurrently. Refresh its result.": "操作已被同时确认，请刷新结果。",
  "Preview only — sample data, no rewards or payments": "仅供预览：示例数据，不产生奖励或付款",
  "Illustrative data only": "仅为示例数据",
  "Transfer": "转账",
  "Stored reservation transaction snapshot is invalid.": "保存的预留交易快照无效。",
  "This reward belongs to a different chain or Vault configuration. Restore its original context before verification or recovery.": "此奖励属于另一条链或金库配置，请恢复原环境后再核验或恢复。",
  "This receipt has no recorded payment to reconcile.": "此小票没有可对账的付款记录。",
  "Receipt is no longer available.": "小票已不可用。",
  "Payment rechecks are busy. Retry shortly.": "付款复核繁忙，请稍后重试。",
  "Automatic review cannot alter a manual decision or unqueued receipt.": "自动审核不能修改人工决定或未排队的小票。",
  "Receipt requires manual review.": "此小票需要人工复核。",
  "Select a supported merchant before approval.": "批准前请选择支持的商户。",
  "A bounded positive integer-cent total is required.": "总额须为允许范围内的正整数美分。",
  "Receipt total exceeds the configured maximum.": "小票总额超出配置上限。",
  "Only USD receipts are supported.": "仅支持美元小票。",
  "A valid receipt date is required.": "需要有效的小票日期。",
  "Receipt is outside the accepted age window.": "小票日期不在允许的范围内。",
  "This merchant receipt number already earned a reward.": "此商户小票编号已经获得奖励。",
  "Daily receipt count limit has been reached.": "已达到每日小票数量上限。",
  "Daily allowance is exhausted.": "今日奖励额度已用完。",
  "Reward budget is insufficient; receipt remains queued.": "奖励预算不足，小票继续排队。",
  "Stock exchange awaits an explicitly reviewed price-protection limit.": "股票兑换需要明确审核过的价格保护限额。",
  "A fresh stock reference price is unavailable. No exchange has been prepared. Try again later.": "暂时无法获取新鲜的股票参考报价，未准备兑换，请稍后再试。",
  "The stock reference quote is stale or does not match this exchange. Refresh the quote.": "股票参考报价已过期或与此兑换不符，请刷新报价。",
  "This pool gives too little compared with the current stock reference quote. Try a smaller amount or wait for a better route.": "此池的到账量明显低于当前股票参考报价，请尝试更小金额或等待更好的路线。",
  "Enter a valid positive amount.": "请输入有效正数。",
  "Wallet balances are unavailable until the BSC read-only connection is configured.": "配置 BSC 只读连接后才能查询钱包余额。",
  "The read-only connection is on a different network.": "只读连接指向另一条链。",
  "The BSC connection is returning an outdated block. Refresh before continuing.": "BSC 连接返回了过时区块，请刷新后继续。",
  "Select an asset from this server's wallet list.": "请从服务器的钱包资产列表中选择。",
  "The selected asset metadata could not be verified.": "无法核验所选资产信息。",
  "Exchange is awaiting configured and verified settlement contracts.": "兑换结算合约尚待配置和核验。",
  "A configured swap contract does not match its verified runtime code.": "配置的兑换合约与已验证代码不符。",
  "Settlement settings no longer match the reviewed configuration.": "结算设置与已审核配置不符。",
  "Keep enough BNB for the transfer amount and estimated network gas.": "请保留足够 BNB，用于转账金额和预计网络费。",
  "Transfers are not enabled on this server.": "服务器尚未启用转账。",
  "Enter a different, nonzero BSC recipient address.": "请输入不同于自己且非零的 BSC 接收地址。",
  "No available balance for this transfer.": "没有可用于此次转账的余额。",
  "The amount exceeds your current wallet balance.": "数量超过当前钱包余额。",
  "The balance is too small after reserving network gas.": "预留网络费后余额不足。",
  "The token rejected this transfer.": "代币合约拒绝了此次转账。",
  "Slippage exceeds the configured limit.": "滑点超过配置上限。",
  "Choose two different underlying assets.": "请选择两种不同的基础资产。",
  "No reviewed BSC route is available for this pair.": "此交易对暂无经过审核的 BSC 路线。",
  "The reviewed pools cannot quote this amount. Try a smaller amount or another pair.": "已审核的池子无法对该数量报价，请尝试更小金额或其他交易对。",
  "The amount is too small after rounding and fees.": "取整和扣费后数量过小。",
  "Refresh the quote and review the amounts again.": "请刷新报价并重新核对金额。",
  "Your input balance is below the quoted amount.": "输入资产余额低于报价所需数量。",
  "The quote expired during validation. Refresh it before proceeding.": "报价在核验期间过期，请刷新后继续。",
  "Transaction not found yet. Keep the hash; do not resend automatically.": "暂未查到交易，请保留哈希，不要自动重发。",
  "This hash does not match the reviewed sender, recipient, asset or amount.": "此哈希与已审阅的发送方、接收方、资产或数量不符。",
  "Submitted; waiting for a block. A timeout is not a failed transaction.": "已提交，等待出块。超时不等于交易失败。",
  "The transaction block changed. Waiting for canonical confirmation.": "交易所在区块已变化，正在等待有效链上确认。",
  "Waiting for": "正在等待",
  "The transaction reverted. No transfer or exchange is marked successful.": "交易已回滚，转账或兑换均未标记为成功。",
  "The expected recipient token transfer is missing or differs from the reviewed amount.": "未发现预期的接收方转账，或数量与审阅内容不符。",
  "Approval": "授权",
  "The exact reviewed approval was not observed.": "未观察到审阅时指定的精确授权。",
  "Settlement runtime code at execution does not match the reviewed contract.": "执行时的结算合约代码与已审核代码不符。",
  "Exchanged": "已兑换",
  "The swap output or service fee does not match the reviewed settlement.": "兑换到账量或服务费与审阅的结算内容不符。",
  "Recipient or fee token transfer proof is incomplete.": "接收方或服务费转账凭据不完整。",
  "Exchange and net output verified on BSC.": "BSC 兑换及净到账量已验证。",
  "Exact token approval confirmed. Refresh the quote before swapping.": "精确代币授权已确认，兑换前请刷新报价。",
  "Transfer to the reviewed recipient verified.": "向已审阅接收方的转账已验证。",
  "This review expired. Prepare and review a fresh transaction.": "此审阅已过期，请重新准备并审阅交易。",
  "Transfers were disabled.": "转账功能已关闭。",
  "The exchange is missing its protected output.": "兑换缺少受保护的最低到账量。",
  "The review expired during validation. Prepare a fresh transaction.": "审阅在核验期间过期，请准备新交易。",
  "Wallet verification changed. Sign in again.": "钱包验证状态已变化，请重新登录。",
  "Action ID is invalid.": "操作编号无效。",
  "This wallet action was not found.": "未找到此钱包操作。",
  "Max must be a boolean.": "“全部”选项须为是或否。",
  "Refresh the quote.": "请刷新报价。",
  "Refresh the quote and review the new amounts.": "请刷新报价并审阅新金额。",
  "This wallet action was already opened. Recover its transaction instead of sending it again.": "此钱包操作已经打开，请恢复原交易，不要重复发送。",
  "The original transaction is still confirmed. Its proof cannot be replaced.": "原交易仍然已确认，不能替换其凭据。",
  "A newer transaction check completed. Refresh this action.": "已有更新的交易核验结果，请刷新此操作。",
  "Check your wallet for an existing transaction before taking another action.": "进行其他操作前，请检查钱包中是否已有交易。",
  "No transaction hash has been recorded.": "尚未记录交易哈希。"
}
